import { __awaiter } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, Input, ViewChild, ChangeDetectorRef, EventEmitter as EventEmitter$1, ChangeDetectionStrategy, Output, HostListener, forwardRef, ViewChildren, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { utils } from '@blue/services';
import { throwOn } from '@blue/services/utils';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { registerBmFormCore } from '@blue/form-element';
import { EventEmitter } from 'events';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { BentoModalConfirmationCloseReason, BentoModalConfirmationService, BentoModule } from '@bento/bento-ng';
import { CommonModule, DatePipe } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { BfmModule } from '@bento/bfm-ng';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
import * as ɵngcc2 from '@bento/bento-ng';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc6 from '@bento/bfm-ng';

const _c0 = ["newGroup"];
function CustomFieldsComponent_bmc_custom_field_group_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bmc-custom-field-group", 7, 8);
    ɵngcc0.ɵɵlistener("changeEntity", function CustomFieldsComponent_bmc_custom_field_group_4_Template_bmc_custom_field_group_changeEntity_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.changeEventReceived($event); })("groupDeleteEvent", function CustomFieldsComponent_bmc_custom_field_group_4_Template_bmc_custom_field_group_groupDeleteEvent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.groupDeleteEventReceived($event); })("groupMoveUp", function CustomFieldsComponent_bmc_custom_field_group_4_Template_bmc_custom_field_group_groupMoveUp_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.groupMoveUpEventReceived($event); })("groupMoveDown", function CustomFieldsComponent_bmc_custom_field_group_4_Template_bmc_custom_field_group_groupMoveDown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.groupMoveDownEventReceived($event); })("clickEvent", function CustomFieldsComponent_bmc_custom_field_group_4_Template_bmc_custom_field_group_clickEvent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.clickEventReceived($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("group", group_r2)("filters", ctx_r0.filters);
} }
function FormElementsComponent_div_0_div_1_bm_form_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bm-form-container", 5);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("items", ctx_r2.items)("layout", ctx_r2.layout)("data", ctx_r2.data)("serviceRef", ctx_r2.setServiceRef);
} }
function FormElementsComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, FormElementsComponent_div_0_div_1_bm_form_container_1_Template, 1, 4, "bm-form-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.displayForm);
} }
function FormElementsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, FormElementsComponent_div_0_div_1_Template, 2, 1, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.items);
} }
const _c1 = ["fieldSelect"];
function CustomFieldGroupComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r6 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngValue", type_r6)("selected", type_r6.key === ctx_r2.group.filter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", type_r6.value, " ");
} }
function CustomFieldGroupComponent_bmc_custom_field_field_14_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bmc-custom-field-field", 19);
    ɵngcc0.ɵɵlistener("fieldDeleteEvent", function CustomFieldGroupComponent_bmc_custom_field_field_14_Template_bmc_custom_field_field_fieldDeleteEvent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.fieldDeleteEventReceived($event); })("fieldMoveUp", function CustomFieldGroupComponent_bmc_custom_field_field_14_Template_bmc_custom_field_field_fieldMoveUp_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.fieldMoveUpEventReceived($event); })("fieldMoveDown", function CustomFieldGroupComponent_bmc_custom_field_field_14_Template_bmc_custom_field_field_fieldMoveDown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.fieldMoveDownEventReceived($event); })("fieldChange", function CustomFieldGroupComponent_bmc_custom_field_field_14_Template_bmc_custom_field_field_fieldChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.fieldChangeEventReceived($event); })("clickEvent", function CustomFieldGroupComponent_bmc_custom_field_field_14_Template_bmc_custom_field_field_clickEvent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.clickEventReceived($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r7 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("group", ctx_r3.group)("field", field_r7);
} }
const _c2 = ["numberTextHover"];
const _c3 = ["dateHover"];
const _c4 = ["checkboxHover"];
const _c5 = ["listHover"];
function CustomFieldFieldComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 5)(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵelement(6, "input", 7);
    ɵngcc0.ɵɵelementStart(7, "button", 8, 9);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.field.editMode);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.field.name);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.field.name ? ctx_r0.field.name : "default-label");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", (ctx_r0.field.name ? ctx_r0.field.name : "default-name") + ", " + ɵngcc0.ɵɵpipeBind1(9, 5, "Bluemoon.DMS.Common.Buttons.Edit"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 7, "Bluemoon.DMS.Common.Buttons.Edit"), "");
} }
function CustomFieldFieldComponent_div_6_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵelement(1, "i", 14);
    ɵngcc0.ɵɵelementEnd();
} }
function CustomFieldFieldComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 5)(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵelementStart(5, "div", 6)(6, "div");
    ɵngcc0.ɵɵelement(7, "input", 10);
    ɵngcc0.ɵɵtemplate(8, CustomFieldFieldComponent_div_6_span_8_Template, 2, 0, "span", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 8, 12);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.field.editMode);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.field.name);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r1.field.name ? ctx_r1.field.name : "default-label");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.field.type === "date");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", (ctx_r1.field.name ? ctx_r1.field.name : "default-name") + ", " + ɵngcc0.ɵɵpipeBind1(11, 6, "Bluemoon.DMS.Common.Buttons.Edit"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 8, "Bluemoon.DMS.Common.Buttons.Edit"), "");
} }
function CustomFieldFieldComponent_div_7_ng_container_2_input_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 19);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r9.getAriaLabelledBy(ctx_r9.field.name));
} }
function CustomFieldFieldComponent_div_7_ng_container_2_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("id", ctx_r10.getAriaLabelledBy(ctx_r10.field.name));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.field.name);
} }
function CustomFieldFieldComponent_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6)(2, "div");
    ɵngcc0.ɵɵtemplate(3, CustomFieldFieldComponent_div_7_ng_container_2_input_3_Template, 1, 1, "input", 16);
    ɵngcc0.ɵɵtemplate(4, CustomFieldFieldComponent_div_7_ng_container_2_label_4_Template, 2, 2, "label", 17);
    ɵngcc0.ɵɵelement(5, "br");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 8, 18);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.field.type === "checkbox");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.field.type === "checkbox");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", (ctx_r7.field.name ? ctx_r7.field.name : "default-name") + ", " + ɵngcc0.ɵɵpipeBind1(8, 4, "Bluemoon.DMS.Common.Buttons.Edit"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 6, "Bluemoon.DMS.Common.Buttons.Edit"), "");
} }
function CustomFieldFieldComponent_div_7_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵelement(1, "i", 14);
    ɵngcc0.ɵɵelementEnd();
} }
function CustomFieldFieldComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 5);
    ɵngcc0.ɵɵtemplate(2, CustomFieldFieldComponent_div_7_ng_container_2_Template, 11, 8, "ng-container", 15);
    ɵngcc0.ɵɵtemplate(3, CustomFieldFieldComponent_div_7_span_3_Template, 2, 0, "span", 11);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r2.field.editMode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.field.type === "checkbox");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.field.type === "date");
} }
function CustomFieldFieldComponent_div_8_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const prod_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(prod_r14.name);
} }
function CustomFieldFieldComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 5)(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵelementStart(5, "div", 21)(6, "select", 22);
    ɵngcc0.ɵɵelement(7, "option", 10);
    ɵngcc0.ɵɵtemplate(8, CustomFieldFieldComponent_div_8_option_8_Template, 2, 1, "option", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 8, 24);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r3.field.editMode);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.field.name);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r3.field.name ? ctx_r3.field.name : "default-label");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.field.listOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", (ctx_r3.field.name ? ctx_r3.field.name : "default-name") + ", " + ɵngcc0.ɵɵpipeBind1(11, 6, "Bluemoon.DMS.Common.Buttons.Edit"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 8, "Bluemoon.DMS.Common.Buttons.Edit"), "");
} }
const _c6 = ["firstNameInput"];
const _c7 = ["container"];
const _c8 = ["deleteButton"];
const _c9 = ["moveUpButton"];
const _c10 = ["moveDownButton"];
const _c11 = ["toggleNameField"];
const _c12 = ["newListOption"];
const _c13 = ["listInput"];
const _c14 = ["listOptionInput"];
const _c15 = ["deleteOptionButton"];
function CustomFieldEditModeComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "button", 6, 7);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.entity.name, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", (ctx_r1.entity.name ? ctx_r1.entity.name : "default-name") + ", " + ɵngcc0.ɵɵpipeBind1(4, 3, "Bluemoon.DMS.Common.Buttons.Edit"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 5, "Bluemoon.DMS.Common.Buttons.Edit"));
} }
function CustomFieldEditModeComponent_form_3_label_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "Bluemoon.Core.CustomFields.FieldType.Textbox"), " *");
} }
function CustomFieldEditModeComponent_form_3_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "Bluemoon.Core.CustomFields.FieldType.Date"), " *");
} }
function CustomFieldEditModeComponent_form_3_label_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "Bluemoon.Core.CustomFields.FieldType.Number"), " *");
} }
function CustomFieldEditModeComponent_form_3_label_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "Bluemoon.Core.CustomFields.FieldType.Group"), " *");
} }
function CustomFieldEditModeComponent_form_3_label_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "Bluemoon.Core.CustomFields.FieldType.Checkbox"), " *");
} }
function CustomFieldEditModeComponent_form_3_label_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "Bluemoon.Core.CustomFields.FieldType.List"), " *");
} }
function CustomFieldEditModeComponent_form_3_i_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 23);
} }
function CustomFieldEditModeComponent_form_3_i_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 24);
} }
function CustomFieldEditModeComponent_form_3_i_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 25);
} }
function CustomFieldEditModeComponent_form_3_ng_container_32_div_6_i_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 23);
} }
function CustomFieldEditModeComponent_form_3_ng_container_32_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 30)(2, "div", 31)(3, "input", 32, 33);
    ɵngcc0.ɵɵlistener("ngModelChange", function CustomFieldEditModeComponent_form_3_ng_container_32_div_6_Template_input_ngModelChange_3_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r29); const option_r22 = restoredCtx.$implicit; return option_r22.name = $event; });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "div", 34)(7, "button", 35, 36);
    ɵngcc0.ɵɵlistener("click", function CustomFieldEditModeComponent_form_3_ng_container_32_div_6_Template_button_click_7_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r29); const option_r22 = restoredCtx.$implicit; const ctx_r30 = ɵngcc0.ɵɵnextContext(3); return ctx_r30.deleteOptionClicked(option_r22); });
    ɵngcc0.ɵɵtemplate(9, CustomFieldEditModeComponent_form_3_ng_container_32_div_6_i_9_Template, 1, 0, "i", 14);
    ɵngcc0.ɵɵelementStart(10, "span", 15);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd()()()();
    ɵngcc0.ɵɵelement(13, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r22 = ctx.$implicit;
    const i_r23 = ctx.index;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("name", "optionName", i_r23, "");
    ɵngcc0.ɵɵpropertyInterpolate2("placeholder", "", ctx_r20.listOptionString, " ", i_r23 + 1, "");
    ɵngcc0.ɵɵproperty("bfmLabel", ctx_r20.listOptionValidationLabel)("ngModel", option_r22.name);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r20.entity.listOptions.length <= 2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r20.entity.editMode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", option_r22.name, ", ", ɵngcc0.ɵɵpipeBind1(12, 9, "Bluemoon.Core.CustomFields.DeleteModal.Delete"), "");
} }
function CustomFieldEditModeComponent_form_3_ng_container_32_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "br");
    ɵngcc0.ɵɵelementStart(2, "fieldset")(3, "legend");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, CustomFieldEditModeComponent_form_3_ng_container_32_div_6_Template, 14, 11, "div", 26);
    ɵngcc0.ɵɵelementStart(7, "button", 27, 28);
    ɵngcc0.ɵɵlistener("click", function CustomFieldEditModeComponent_form_3_ng_container_32_Template_button_click_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.addListOption($event); });
    ɵngcc0.ɵɵelement(9, "span", 29);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(5, 3, "Bluemoon.Core.CustomFields.Options"), " *");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r19.entity.listOptions);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 5, "Bluemoon.Core.CustomFields.AddOption"));
} }
const _c16 = function (a0) { return { "showInvalid": a0 }; };
function CustomFieldEditModeComponent_form_3_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 8, 9)(2, "div", 5);
    ɵngcc0.ɵɵtemplate(3, CustomFieldEditModeComponent_form_3_label_3_Template, 3, 3, "label", 10);
    ɵngcc0.ɵɵtemplate(4, CustomFieldEditModeComponent_form_3_label_4_Template, 3, 3, "label", 10);
    ɵngcc0.ɵɵtemplate(5, CustomFieldEditModeComponent_form_3_label_5_Template, 3, 3, "label", 10);
    ɵngcc0.ɵɵtemplate(6, CustomFieldEditModeComponent_form_3_label_6_Template, 3, 3, "label", 10);
    ɵngcc0.ɵɵtemplate(7, CustomFieldEditModeComponent_form_3_label_7_Template, 3, 3, "label", 10);
    ɵngcc0.ɵɵtemplate(8, CustomFieldEditModeComponent_form_3_label_8_Template, 3, 3, "label", 10);
    ɵngcc0.ɵɵelementStart(9, "div", 11)(10, "button", 12, 13);
    ɵngcc0.ɵɵtemplate(12, CustomFieldEditModeComponent_form_3_i_12_Template, 1, 0, "i", 14);
    ɵngcc0.ɵɵelementStart(13, "span", 15);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵpipe(15, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(16, "button", 16, 17);
    ɵngcc0.ɵɵtemplate(18, CustomFieldEditModeComponent_form_3_i_18_Template, 1, 0, "i", 18);
    ɵngcc0.ɵɵelementStart(19, "span", 15);
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵpipe(21, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(22, "button", 16, 19);
    ɵngcc0.ɵɵtemplate(24, CustomFieldEditModeComponent_form_3_i_24_Template, 1, 0, "i", 20);
    ɵngcc0.ɵɵelementStart(25, "span", 15);
    ɵngcc0.ɵɵtext(26);
    ɵngcc0.ɵɵpipe(27, "translate");
    ɵngcc0.ɵɵelementEnd()()()();
    ɵngcc0.ɵɵelementStart(28, "input", 21, 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function CustomFieldEditModeComponent_form_3_Template_input_ngModelChange_28_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.entity.name = $event; });
    ɵngcc0.ɵɵpipe(31, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(32, CustomFieldEditModeComponent_form_3_ng_container_32_Template, 12, 7, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("validations", ctx_r2.validations);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.type === ctx_r2.FieldType.Textbox);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.type === ctx_r2.FieldType.Date);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.type === ctx_r2.FieldType.Number);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.type === ctx_r2.FieldType.Group);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.type === ctx_r2.FieldType.Checkbox);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.type === ctx_r2.FieldType.List);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.editMode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r2.entity.name, ", ", ɵngcc0.ɵɵpipeBind1(15, 24, "Bluemoon.Core.CustomFields.DeleteModal.Delete"), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.firstEntity);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.editMode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r2.entity.name, ", ", ɵngcc0.ɵɵpipeBind1(21, 26, "Bluemoon.Core.CustomFields.DeleteModal.MoveUp"), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.lastEntity);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.editMode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r2.entity.name, ", ", ɵngcc0.ɵɵpipeBind1(27, 28, "Bluemoon.Core.CustomFields.DeleteModal.MoveDown"), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("bfmLabel", ctx_r2.formValidationLabel)("ngModel", ctx_r2.entity.name)("placeholder", ɵngcc0.ɵɵpipeBind1(31, 30, ctx_r2.placeholderMap.get(ctx_r2.entity.type)) || "")("ngClass", ɵngcc0.ɵɵpureFunction1(32, _c16, ctx_r2.showInvalid));
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.entity.name);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.entity.type === ctx_r2.FieldType.List);
} }
var FieldType;
(function (FieldType) {
    FieldType["Group"] = "group";
    FieldType["Textbox"] = "textbox";
    FieldType["List"] = "list";
    FieldType["Checkbox"] = "checkbox";
    FieldType["Date"] = "date";
    FieldType["Number"] = "number";
    FieldType["Staff"] = "staff";
    FieldType["ListOption"] = "listOption";
})(FieldType || (FieldType = {}));
var CallbackType;
(function (CallbackType) {
    CallbackType[CallbackType["SaveSuccess"] = 0] = "SaveSuccess";
    CallbackType[CallbackType["CancelSuccess"] = 1] = "CancelSuccess";
    CallbackType[CallbackType["SaveUserError"] = 2] = "SaveUserError";
    CallbackType[CallbackType["SaveServerError"] = 3] = "SaveServerError";
    CallbackType[CallbackType["LoadSuccess"] = 4] = "LoadSuccess";
    CallbackType[CallbackType["LoadError"] = 5] = "LoadError";
    CallbackType[CallbackType["NavigationNoSave"] = 6] = "NavigationNoSave";
})(CallbackType || (CallbackType = {}));
var SaveType;
(function (SaveType) {
    SaveType[SaveType["Manual"] = 0] = "Manual";
    SaveType[SaveType["NavigationAway"] = 1] = "NavigationAway";
})(SaveType || (SaveType = {}));
// export interface ListOption extends Entity {}
var ClickType;
(function (ClickType) {
    ClickType[ClickType["MoveUp"] = 0] = "MoveUp";
    ClickType[ClickType["MoveDown"] = 1] = "MoveDown";
    ClickType[ClickType["Delete"] = 2] = "Delete";
    ClickType[ClickType["Undertermined"] = 3] = "Undertermined";
    ClickType[ClickType["Other"] = 4] = "Other";
})(ClickType || (ClickType = {}));

class CustomFieldsService {
    registerSaveFunction(fn) {
        this.saveFunction = fn;
    }
    save(saveType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.saveFunction) {
                return this.saveFunction(saveType);
            }
            else {
                throw new Error('Save function is undefined.');
            }
        });
    }
    registerLoadFunction(fn) {
        this.loadFunction = fn;
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loadFunction) {
                return this.loadFunction();
            }
            else {
                throw new Error('Load function is undefined.');
            }
        });
    }
}
CustomFieldsService.ɵfac = function CustomFieldsService_Factory(t) { return new (t || CustomFieldsService)(); };
CustomFieldsService.ɵprov = ɵɵdefineInjectable({ factory: function CustomFieldsService_Factory() { return new CustomFieldsService(); }, token: CustomFieldsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomFieldsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
function canChangeEditModeToFalse(entity) {
    if (entity.editMode) {
        if (entity.type === FieldType.List && !!entity.name && listOptionsValid(entity)) {
            return true;
        }
        else if (entity.type !== FieldType.List && !!entity.name) {
            return true;
        }
    }
    return false;
}
function entityValid(entity) {
    if (entity.type !== FieldType.List) {
        if (!!entity.name) {
            return true;
        }
    }
    else {
        if (!!entity.name && listOptionsValid(entity)) {
            return true;
        }
    }
    return false;
}
function listOptionsValid(field) {
    const invalidField = field.listOptions.find((option) => !option.name);
    return !invalidField;
}

class CustomFieldsComponent {
    constructor(cfService, translate) {
        this.cfService = cfService;
        this.translate = translate;
        this.groups = [];
        this.alerts = [];
        this.isMainBusyLoaderBusy = false;
        this.scrollPosition = 0;
        this.successTranslation = '';
        this.userFailTranslation = '';
        this.serverFailTranslation = '';
        this.loadFailTranslation = '';
        this.saveBtnTranslation = '';
        this.canChangeEditModeToFalse = canChangeEditModeToFalse;
        this.validateTextFields = this.validateTextFields.bind(this);
        this.getJsonData = this.getJsonData.bind(this);
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // Per design start the app with a blank group for the user to populate
            // we will need to do a fetch to see if a user has custom fields and if
            // not display this empty state for the user.
            this.cfService.registerSaveFunction(this.validateTextFields);
            this.cfService.registerLoadFunction(this.getJsonData);
            this.successTranslation = yield this.translate.get('Bluemoon.Core.CustomFields.SaveSuccessAlert').toPromise();
            this.userFailTranslation = yield this.translate.get('Bluemoon.Core.CustomFields.UserErrorAlert').toPromise();
            this.serverFailTranslation = yield this.translate.get('Bluemoon.Core.CustomFields.ServerErrorAlert').toPromise();
            this.loadFailTranslation = yield this.translate.get('Bluemoon.Core.CustomFields.GenericErrorAlert').toPromise();
            this.saveBtnTranslation = yield this.translate.get('Bluemoon.DMS.Modal.NewDocument.Document.Save').toPromise();
        });
    }
    ngAfterViewChecked() {
        const bentoAlertItem = document.querySelector('#bentoAlert > div.alert-container.refresh-data > bento-alert-item > div');
        const inlineErrorSpanTag = document.querySelector('bfm-error-container > div > bfm-error > div > span');
        const inlineErrorItem = inlineErrorSpanTag === null || inlineErrorSpanTag === void 0 ? void 0 : inlineErrorSpanTag.closest('bfm-error-container');
        if (bentoAlertItem) {
            bentoAlertItem.focus();
            setTimeout(() => {
                const activeElement = document.activeElement;
                if (activeElement && activeElement.textContent === this.saveBtnTranslation) {
                    const parent = inlineErrorItem === null || inlineErrorItem === void 0 ? void 0 : inlineErrorItem.parentElement;
                    const inputElement = parent.querySelector('input');
                    inputElement.focus();
                }
            }, 4000);
        }
    }
    clickEventReceived(event) {
        if (this.canChangeEditModeToFalse(event.entity) && event.entity.type === FieldType.Group) {
            // Need this if else because for some reason two click events are emitted when a group is moved down
            // Something to do with the splicing and component instances??
            if (event.entity.focus !== 'DownButton') {
                this.changeEventReceived(Object.assign(Object.assign({}, event.entity), { editMode: false, focus: 'NameField' }));
            }
            else {
                this.changeEventReceived(Object.assign(Object.assign({}, event.entity), { focus: 'None' }));
            }
        }
    }
    addGroupComponent() {
        this.groups.push({
            id: utils.generateUUID(),
            filter: this.filters[0].value,
            name: '',
            type: FieldType.Group,
            editMode: true,
            invalid: false,
            newEntity: true,
            focus: 'NameField',
            fields: []
        });
    }
    trackByFn(index) {
        return index;
    }
    changeEventReceived(event) {
        const oldGroup = this.groups.find(group => group.id === event.id);
        const currentIndex = this.groups.indexOf(oldGroup);
        this.groups.splice(currentIndex, 1, event);
    }
    groupDeleteEventReceived(group) {
        const currentIndex = this.groups.indexOf(group);
        this.groups.splice(currentIndex, 1);
    }
    groupMoveUpEventReceived(group) {
        const currentIndex = this.groups.indexOf(group);
        if (currentIndex !== 0) {
            this.groups.splice(currentIndex, 1);
            this.groups.splice(currentIndex - 1, 0, Object.assign(Object.assign({}, group), { focus: 'UpButton' }));
        }
    }
    groupMoveDownEventReceived(group) {
        const currentIndex = this.groups.indexOf(group);
        if (currentIndex !== this.groups.length - 1) {
            this.groups.splice(currentIndex, 1);
            this.groups.splice(currentIndex + 1, 0, Object.assign(Object.assign({}, group), { focus: 'DownButton' }));
        }
    }
    validateTextFields(saveType) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isMainBusyLoaderBusy = true;
            this.scrollPosition = window.scrollY;
            window.scrollTo({ top: 0 });
            if (saveType === SaveType.NavigationAway &&
                this.groups &&
                this.groups.length === 1 &&
                this.groups[0].fields.length === 0 &&
                !entityValid(this.groups[0])) {
                this.isMainBusyLoaderBusy = false;
                return Promise.resolve(CallbackType.NavigationNoSave);
            }
            let allValid = true;
            this.groups.forEach((g) => {
                if (!entityValid(g)) {
                    allValid = false;
                }
                else {
                    g.newEntity = false;
                    g.focus = 'NameField';
                    g.editMode = false;
                }
                g.fields.forEach((f) => {
                    if (!entityValid(f)) {
                        allValid = false;
                    }
                    else {
                        f.newEntity = false;
                        f.focus = 'NameField';
                        f.editMode = false;
                    }
                });
            });
            if (allValid) {
                // Formerly generate new json method
                const parentObj = {};
                const itemsObj = {};
                const layoutObj = {
                    type: 'flex',
                    options: []
                };
                const itemsKey = 'items';
                const layoutKey = 'layout';
                const dataKey = 'data';
                parentObj[itemsKey] = itemsObj;
                parentObj[layoutKey] = layoutObj;
                parentObj[dataKey] = this.groups;
                const jsonParentObj = JSON.stringify(parentObj);
                if (this.currentLayoutId) {
                    try {
                        yield this.updateJsonData(jsonParentObj);
                        if (saveType === SaveType.Manual) {
                            this.setSuccessAlert(CallbackType.SaveSuccess);
                        }
                        return Promise.resolve(CallbackType.SaveSuccess);
                    }
                    catch (_a) {
                        this.setFailureAlert(CallbackType.SaveServerError);
                        return Promise.reject(CallbackType.SaveServerError);
                    }
                    finally {
                        this.isMainBusyLoaderBusy = false;
                    }
                }
                else {
                    try {
                        yield this.postJsonData(jsonParentObj);
                        if (saveType === SaveType.Manual) {
                            this.setSuccessAlert(CallbackType.SaveSuccess);
                        }
                        return Promise.resolve(CallbackType.SaveSuccess);
                    }
                    catch (_b) {
                        this.setFailureAlert(CallbackType.SaveServerError);
                        return Promise.reject(CallbackType.SaveServerError);
                    }
                    finally {
                        this.isMainBusyLoaderBusy = false;
                    }
                }
            }
            else {
                this.isMainBusyLoaderBusy = false;
                this.setFailureAlert(CallbackType.SaveUserError);
                return Promise.reject(CallbackType.SaveUserError);
            }
        });
    }
    // When we are iterating over fields this code generates the json for each field which will be consumed by the form-elememts repo
    // https://blue-docs.int.thomsonreuters.com/docs/@blue-form-element/master/index.html
    resetData() {
        this.groups = [];
    }
    loadData(jsonData) {
        if (jsonData.length < 1) {
            this.groups.splice(0, this.groups.length);
            this.groups.push({
                id: utils.generateUUID(),
                filter: this.filters[0].key,
                name: '',
                type: FieldType.Group,
                editMode: true,
                invalid: false,
                newEntity: true,
                focus: 'NameField',
                fields: []
            });
            return;
        }
        const realData = JSON.parse(jsonData[0].layoutJson);
        this.currentLayoutId = jsonData[0].id;
        this.groups = realData.data;
        if (this.groups.length < 1) {
            this.groups.push({
                id: utils.generateUUID(),
                filter: this.filters[0].key,
                name: '',
                type: FieldType.Group,
                editMode: true,
                invalid: false,
                newEntity: true,
                focus: 'NameField',
                fields: []
            });
        }
        else {
            this.initializeData();
        }
    }
    postJsonData(jsonOutput) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = '/api/custom-fields/v1/layout/';
            const data = {
                layoutJson: jsonOutput,
                category: this.category,
                filterRule: 'All Clients'
            };
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Origin': '*'
            };
            yield fetch(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            })
                .then(response => throwOn(response, status => status >= 400))
                .then(response => response.json())
                .then(jsonBody => {
                return Promise.resolve('SaveSuccess');
            })
                .catch(error => {
                return Promise.reject(); // 'an error occurred';
            });
        });
    }
    updateJsonData(jsonOutput) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = '/api/custom-fields/v1/layout/' + this.currentLayoutId;
            const data = {
                layoutJson: jsonOutput,
                category: this.category,
                filterRule: 'All Clients'
            };
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Origin': '*'
            };
            yield fetch(url, {
                method: 'PUT',
                headers,
                body: JSON.stringify(data)
            })
                .then(response => throwOn(response, status => status >= 400))
                .then(response => response.json())
                .then(jsonBody => {
                console.log('DATA SUCCESSFULLY SAVED');
                // TODO Add success confirmation
                return Promise.resolve(CallbackType.SaveSuccess);
            })
                .catch(error => {
                return Promise.reject(CallbackType.SaveServerError);
            });
        });
    }
    getJsonData() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryUrl = '/api/custom-fields/v1/layout/' + this.category;
            this.isMainBusyLoaderBusy = true;
            window.scrollTo({ top: 0 });
            yield fetch(queryUrl, {
                headers: {
                    Accept: 'application/json'
                }
            })
                .then(response => throwOn(response, status => status >= 400))
                .then(response => response.json())
                .then(jsonBody => {
                this.isMainBusyLoaderBusy = false;
                this.loadData(jsonBody);
                this.setSuccessAlert(CallbackType.LoadSuccess);
                return Promise.resolve(CallbackType.LoadSuccess);
            })
                .catch(error => {
                this.isMainBusyLoaderBusy = false;
                this.setFailureAlert(CallbackType.LoadError);
                return Promise.reject(CallbackType.LoadError);
            });
        });
    }
    setSuccessAlert(type) {
        if (type === CallbackType.SaveSuccess) {
            this.setAlert('success', this.successTranslation, 2500);
        }
    }
    setFailureAlert(type) {
        if (type === CallbackType.SaveUserError) {
            window.scrollTo({ top: this.scrollPosition });
            this.setAlert('danger', this.userFailTranslation, 4000);
        }
        else if (type === CallbackType.SaveServerError) {
            this.setAlert('danger', this.serverFailTranslation, 4000);
        }
        else if (type === CallbackType.LoadError) {
            this.setAlert('danger', this.loadFailTranslation, 4000);
        }
    }
    setAlert(type, msg, timeout) {
        this.alerts.pop();
        this.alerts.push({
            type: `${type}`,
            msg: `${msg}`,
            closeable: true,
            timeout
        });
    }
    initializeData() {
        this.groups.forEach((g) => {
            g.focus = 'NameField';
            g.newEntity = false;
            if (!entityValid(g)) { // in case a field was previously saved while invalid
                g.editMode = true;
            }
            g.fields.forEach((f) => {
                f.focus = 'NameField';
                f.newEntity = false;
                if (!entityValid(f)) {
                    f.editMode = true;
                }
            });
        });
    }
}
CustomFieldsComponent.ɵfac = function CustomFieldsComponent_Factory(t) { return new (t || CustomFieldsComponent)(ɵngcc0.ɵɵdirectiveInject(CustomFieldsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService)); };
CustomFieldsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CustomFieldsComponent, selectors: [["bmc-custom-fields"]], viewQuery: function CustomFieldsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.newGroup = _t.first);
    } }, inputs: { groups: "groups", filters: "filters", category: "category" }, decls: 13, vars: 11, consts: [[1, "customfields-required"], [1, "ng-bento", "customfields-busy-loader", 3, "bentoBusyLoader"], [3, "group", "filters", "changeEntity", "groupDeleteEvent", "groupMoveUp", "groupMoveDown", "clickEvent", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["id", "newGroupBtn", "type", "button", "onkeypress", "addGroupComponent()", 3, "click"], ["newGroup", ""], [1, "bento-icon-add"], ["id", "bentoAlert", 1, "ng-bento", "custom-fields-alert", 3, "inline", "items"], [3, "group", "filters", "changeEntity", "groupDeleteEvent", "groupMoveUp", "groupMoveDown", "clickEvent"], ["childComp", ""]], template: function CustomFieldsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtemplate(4, CustomFieldsComponent_bmc_custom_field_group_4_Template, 2, 2, "bmc-custom-field-group", 2);
        ɵngcc0.ɵɵelementStart(5, "button", 3, 4);
        ɵngcc0.ɵɵlistener("click", function CustomFieldsComponent_Template_button_click_5_listener() { return ctx.addGroupComponent(); });
        ɵngcc0.ɵɵelement(7, "span", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "bento-alert", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "br")(12, "br");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("* ", ɵngcc0.ɵɵpipeBind1(2, 7, "Bluemoon.DMS.Approvals.ConfirmModal.RequiredField"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isMainBusyLoaderBusy);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.groups)("ngForTrackBy", ctx.trackByFn);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 9, "Bluemoon.Core.CustomFields.AddGroup"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("inline", true)("items", ctx.alerts);
    } }, directives: function () { return [ɵngcc2.BentoBusyLoaderDirective, ɵngcc3.NgForOf, CustomFieldGroupComponent, ɵngcc2.BentoAlertComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, styles: ["#newGroupBtn[_ngcontent-%COMP%]{color:#0072a8}[class*=\" bento-icon-\"][_ngcontent-%COMP%], [class^=bento-icon-][_ngcontent-%COMP%]{padding-left:10px;padding-top:4px}button[_ngcontent-%COMP%]{border:0}a[_ngcontent-%COMP%]{text-decoration:none}.card[_ngcontent-%COMP%]{margin-bottom:30px}.custom-fields-alert[_ngcontent-%COMP%]{left:30vw;position:fixed;top:93vh;width:40vw;z-index:1}.customfields-busy-loader[_ngcontent-%COMP%]{height:80vh}.customfields-required[_ngcontent-%COMP%]{margin-left:10px}"] });
CustomFieldsComponent.ctorParameters = () => [
    { type: CustomFieldsService },
    { type: TranslateService }
];
CustomFieldsComponent.propDecorators = {
    groups: [{ type: Input }],
    filters: [{ type: Input }],
    category: [{ type: Input }],
    newGroup: [{ type: ViewChild, args: ['newGroup',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomFieldsComponent, [{
        type: Component,
        args: [{
                selector: 'bmc-custom-fields',
                template: "<span class=\"customfields-required\">* {{'Bluemoon.DMS.Approvals.ConfirmModal.RequiredField' | translate}}</span>\n<div class=\"ng-bento customfields-busy-loader\" [bentoBusyLoader]=\"isMainBusyLoaderBusy\">\n  <bmc-custom-field-group *ngFor=\"let group of groups; trackBy: trackByFn\"\n  [group]=\"group\"\n  [filters]=\"filters\"\n  (changeEntity)=\"changeEventReceived($event)\"\n  (groupDeleteEvent)=\"groupDeleteEventReceived($event)\"\n  (groupMoveUp)=\"groupMoveUpEventReceived($event)\"\n  (groupMoveDown)=\"groupMoveDownEventReceived($event)\"\n  (clickEvent)=\"clickEventReceived($event)\"\n  #childComp>\n  </bmc-custom-field-group>\n\n  <button #newGroup id=\"newGroupBtn\" type=\"button\" onkeypress=\"addGroupComponent()\" (click)=\"addGroupComponent()\" ><span class=\"bento-icon-add\"></span>  {{'Bluemoon.Core.CustomFields.AddGroup' | translate}}</button>\n  <bento-alert id=\"bentoAlert\" class=\"ng-bento custom-fields-alert\" [inline]=\"true\" [items]=\"alerts\"></bento-alert>\n</div>\n<br/><br/>\n",
                styles: ["#newGroupBtn{color:#0072a8}[class*=\" bento-icon-\"],[class^=bento-icon-]{padding-left:10px;padding-top:4px}button{border:0}a{text-decoration:none}.card{margin-bottom:30px}.custom-fields-alert{left:30vw;position:fixed;top:93vh;width:40vw;z-index:1}.customfields-busy-loader{height:80vh}.customfields-required{margin-left:10px}"]
            }]
    }], function () { return [{ type: CustomFieldsService }, { type: ɵngcc1.TranslateService }]; }, { groups: [{
            type: Input
        }], filters: [{
            type: Input
        }], category: [{
            type: Input
        }], newGroup: [{
            type: ViewChild,
            args: ['newGroup']
        }] }); })();

class FormElementsService {
    constructor() {
        this.onFilterUpdateEventEmitter = new EventEmitter();
    }
    registerSaveFunction(fn) {
        this.saveFunction = fn;
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.saveFunction) {
                return this.saveFunction();
            }
            else {
                throw new Error('Save function is undefined.');
            }
        });
    }
    onUpdate(fn) {
        return this.onFilterUpdateEventEmitter.once('update', fn);
    }
    update(filtersArr) {
        this.onFilterUpdateEventEmitter.emit('update', filtersArr);
    }
}
FormElementsService.ɵfac = function FormElementsService_Factory(t) { return new (t || FormElementsService)(); };
FormElementsService.ɵprov = ɵɵdefineInjectable({ factory: function FormElementsService_Factory() { return new FormElementsService(); }, token: FormElementsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormElementsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

registerBmFormCore();
class FormElementsComponent {
    constructor(feService, cdRef) {
        this.feService = feService;
        this.cdRef = cdRef;
        this.groups = [];
        this.displayForm = false;
        this.setServiceRef = this.setServiceRef.bind(this);
        this.saveFormData = this.saveFormData.bind(this);
    }
    setServiceRef(service) {
        this.service = service;
    }
    ngOnInit() {
        this.feService.registerSaveFunction(this.saveFormData);
        const updateObs = this.feService.onUpdate((filtersArr) => {
            this.resetForm();
            this.loadForm();
            this.hasUpdated = true;
        });
        this.getJsonLayoutData();
    }
    getJsonLayoutData() {
        const queryUrl = '/api/custom-fields/v1/layout/' + this.category;
        fetch(queryUrl, {
            method: 'GET',
            headers: {
                Accept: 'text/plain',
            }
        })
            .then(response => throwOn(response, status => status >= 400))
            .then(response => response.json())
            .then(jsonBody => {
            this.loadLayoutData(jsonBody);
            return;
        })
            .catch(error => {
            return 'an error occurred';
        });
    }
    loadLayoutData(jsonData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!jsonData || !jsonData[0]) {
                return;
            }
            const realData = JSON.parse(jsonData[0].layoutJson);
            this.currentLayoutId = jsonData[0].id;
            this.items = realData.items;
            this.layout = realData.layout;
            this.groups = realData.data;
            if (this.groups && this.groups.length > 0) {
                this.displayForm = true;
            }
            yield this.getJsonUserData();
            this.generateNewJson();
        });
    }
    loadUserData(jsonData) {
        if (jsonData.length > 0) {
            this.currentDataId = jsonData[0].id;
            const userData = JSON.parse(jsonData[0].dataJson);
            const userDataObject = new Object();
            this.groups.forEach((group) => {
                var _a;
                if ((_a = this.filters) === null || _a === void 0 ? void 0 : _a.includes(group.filter)) {
                    group.fields.forEach(field => {
                        if ('item' + field.id in userData) {
                            userDataObject['item' + field.id] = userData['item' + field.id];
                        }
                    });
                }
            });
            this.data = userDataObject;
            return Promise.resolve();
        }
    }
    saveFormData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.displayForm) {
                if (this.currentDataId) {
                    yield this.updateJsonData();
                }
                else {
                    yield this.postJsonData();
                }
            }
        });
    }
    postJsonData() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = '/api/custom-fields/v1/data/';
            const data = {
                dataJson: JSON.stringify(this.service.getValue()) || '{}',
                referenceId: this.uniqueref,
                layoutId: this.currentLayoutId,
            };
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Origin': '*'
            };
            try {
                const response = yield fetch(url, {
                    method: 'POST',
                    headers,
                    body: JSON.stringify(data)
                });
                yield throwOn(response, status => status >= 400);
            }
            catch (error) {
                throw new Error('Error occurred during post.');
            }
        });
    }
    updateJsonData() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO
            // -Convert to use getRoute('CustomFieldServices') // returns base up to .../api/custom-fields/
            // -Move web requests to service file per Manuel's recommendation will be done in future branch
            const url = '/api/custom-fields/v1/data/' + this.currentDataId;
            const data = {
                dataJson: JSON.stringify(this.service.getValue()) || '{}',
                referenceId: this.uniqueref,
                layoutId: this.currentLayoutId,
            };
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Origin': '*'
            };
            try {
                const response = yield fetch(url, {
                    method: 'PUT',
                    headers,
                    body: JSON.stringify(data)
                });
                yield throwOn(response, status => status >= 400);
            }
            catch (error) {
                throw new Error('Error occurred during update.');
            }
        });
    }
    getJsonUserData() {
        return __awaiter(this, void 0, void 0, function* () {
            const referenceId = this.uniqueref;
            const queryUrl = '/api/custom-fields/v1/data/' + referenceId;
            try {
                const response = yield fetch(queryUrl, {
                    headers: {
                        method: 'GET',
                        Accept: 'text/plain',
                    }
                });
                yield throwOn(response, status => status >= 400);
                const jsonBody = yield response.json();
                yield this.loadUserData(jsonBody);
            }
            catch (error) {
                console.error('Error while fetching user data:', error);
            }
        });
    }
    generateNewJson() {
        const itemsObj = {};
        const layoutObj = {
            type: 'flex',
            options: []
        };
        this.groups.forEach((group) => {
            // if group in filters, display it.
            if (this.filters.includes(group.filter)) {
                itemsObj[`item${group.id}`] = this.sampleTextLabelNode(group.id, group.name);
                layoutObj.options.push([`item${group.id}`]);
                group.fields.forEach((field) => {
                    if (field.type === FieldType.Textbox) {
                        itemsObj[`item${field.id}`] = this.sampleTextInputNode(field.id, field.name);
                    }
                    if (field.type === FieldType.Number) {
                        itemsObj[`item${field.id}`] = this.sampleNumberInputNode(field.id, field.name);
                    }
                    if (field.type === FieldType.Date) {
                        itemsObj[`item${field.id}`] = this.sampleDateInputNode(field.id, field.name);
                    }
                    if (field.type === FieldType.List) {
                        itemsObj[`item${field.id}`] = this.sampleListNode(field.id, field.name, field);
                    }
                    if (field.type === FieldType.Checkbox) {
                        itemsObj[`item${field.id}`] = this.sampleCheckboxNode(field.id, field.name);
                    }
                    layoutObj.options.push([`item${field.id}`]);
                });
            }
        });
        if (this.items) {
            this.items = {};
        }
        if (this.layout) {
            this.layout = {};
        }
        this.items = itemsObj;
        this.layout = layoutObj;
        if (this.hasUpdated) {
            this.cdRef.detectChanges();
        }
    }
    resetForm() {
        this.layout = {};
        this.items = {};
    }
    loadForm() {
        this.groups = [];
        this.getJsonLayoutData();
    }
    sampleTextLabelNode(runningIndex, title) {
        const textLabelObj = {
            name: `item${runningIndex}`,
            type: `static-label`,
            options: {
                type: `bm-form-label`,
                label: `${title}`,
                styles: `bold`
            }
        };
        return textLabelObj;
    }
    sampleListNode(runningIndex, title, field) {
        const listOfOptions = [];
        field.listOptions.forEach(element => {
            listOfOptions.push(element.name);
        });
        const textLabelObj = {
            name: `item${runningIndex}`,
            type: `dropdown-input-field`,
            options: {
                label: {
                    label: `${title}`,
                    description: `${title}`
                },
                items: listOfOptions
            }
        };
        return textLabelObj;
    }
    sampleTextInputNode(runningIndex, title) {
        const textInputObj = {
            name: `item${runningIndex}`,
            type: `text-input-field`,
            options: {
                label: {
                    label: `${title}`,
                    description: ''
                }
            }
        };
        return textInputObj;
    }
    sampleNumberInputNode(runningIndex, title) {
        const numberInputObj = {
            name: `item${runningIndex}`,
            type: 'number-input-field',
            options: {
                label: {
                    label: `${title}`,
                    description: ''
                },
                mask: {
                    type: 'number',
                    options: {
                        locale: 'en-us',
                        style: 'decimal',
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 10
                    }
                },
            }
        };
        return numberInputObj;
    }
    sampleDateInputNode(runningIndex, title) {
        const dateInputObj = {
            name: `item${runningIndex}`,
            type: 'date-input-field',
            options: {
                label: {
                    label: `${title}`,
                    description: ''
                },
                min: '1901-01-01',
                max: '3020-12-31',
                locale: 'en-US',
            }
        };
        return dateInputObj;
    }
    sampleCheckboxNode(runningIndex, title) {
        const dateInputObj = {
            name: `item${runningIndex}`,
            type: 'checkbox-input-field',
            options: {
                label: `${title}`
            }
        };
        return dateInputObj;
    }
}
FormElementsComponent.ɵfac = function FormElementsComponent_Factory(t) { return new (t || FormElementsComponent)(ɵngcc0.ɵɵdirectiveInject(FormElementsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FormElementsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormElementsComponent, selectors: [["bmc-form-elements"]], inputs: { filters: "filters", category: "category", uniqueref: "uniqueref" }, decls: 2, vars: 1, consts: [["ng-if", "hasUpdated", 4, "ngIf"], ["ng-if", "hasUpdated"], ["class", "formContainer", 4, "ngIf"], [1, "formContainer"], [3, "items", "layout", "data", "serviceRef", 4, "ngIf"], [3, "items", "layout", "data", "serviceRef"]], template: function FormElementsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormElementsComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelement(1, "br");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasUpdated);
    } }, directives: [ɵngcc3.NgIf], styles: ["span.bm-form-label[_ngcontent-%COMP%]{color:#212121;font-family:KnowledgeRegular;font-size:18px;font-weight:400}.formContainer[_ngcontent-%COMP%]{--accent-color:#000;--translucent-color:rgba(0,114,168,0.1)}"] });
FormElementsComponent.ctorParameters = () => [
    { type: FormElementsService },
    { type: ChangeDetectorRef }
];
FormElementsComponent.propDecorators = {
    filters: [{ type: Input }],
    category: [{ type: Input }],
    uniqueref: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormElementsComponent, [{
        type: Component,
        args: [{
                selector: 'bmc-form-elements',
                template: "<div ng-if=\"hasUpdated\" *ngIf=\"hasUpdated\">\n  <div *ngIf=\"items\" class=\"formContainer\">\n    <bm-form-container\n    *ngIf=\"displayForm\"\n    [items]=\"items\"\n    [layout]=\"layout\"\n    [data]=\"data\"\n    [serviceRef]=\"setServiceRef\"></bm-form-container>\n  </div>\n</div>\n<br/>\n",
                styles: ["span.bm-form-label{color:#212121;font-family:KnowledgeRegular;font-size:18px;font-weight:400}.formContainer{--accent-color:#000;--translucent-color:rgba(0,114,168,0.1)}"]
            }]
    }], function () { return [{ type: FormElementsService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { filters: [{
            type: Input
        }], category: [{
            type: Input
        }], uniqueref: [{
            type: Input
        }] }); })();

class CustomFieldGroupComponent {
    constructor() {
        this.FieldType = FieldType;
        this.groupDeleteEvent = new EventEmitter$1();
        this.groupMoveUp = new EventEmitter$1();
        this.groupMoveDown = new EventEmitter$1();
        this.changeEntity = new EventEmitter$1();
        this.clickEvent = new EventEmitter$1();
        this.canChangeEditModeToFalse = canChangeEditModeToFalse;
    }
    clickEventReceived(event) {
        if (event.entity.type === FieldType.Group) {
            this.clickEvent.emit({ element: event.element, entity: this.group });
        }
        else {
            this.fieldExitEditMode(event.entity);
        }
    }
    keydownTabHandler(event) {
        if (this.canChangeLastFieldEditModeFalse(event)) {
            this.fieldExitEditMode(this.group.fields[this.group.fields.length - 1]);
        }
    }
    fieldExitEditMode(field) {
        if (field.type !== FieldType.Group && this.canChangeEditModeToFalse(field)) {
            const newField = Object.assign(Object.assign({}, field), { editMode: false, focus: 'NameField' });
            const currentIndex = this.group.fields.indexOf(field);
            this.group.fields.splice(currentIndex, 1, newField);
        }
    }
    ngAfterViewChecked() {
        const dropdownToggle = document.querySelectorAll('.addNewBtn');
        dropdownToggle.forEach((button) => {
            const parentElement = button.closest('.d-inline-block');
            const ariaLiveDiv = parentElement.querySelector('#updateAriaExpand');
            if (document.activeElement === button) {
                const status = button.getAttribute('aria-expanded');
                status === 'true' ? ariaLiveDiv.textContent = 'Expanded' : ariaLiveDiv.textContent = '';
            }
            else {
                ariaLiveDiv.textContent = '';
            }
        });
    }
    addFieldClicked(fieldType) {
        if (fieldType === FieldType.List) {
            this.group.fields.push({
                id: utils.generateUUID(),
                type: FieldType.List,
                name: '',
                isRequired: false,
                editMode: true,
                invalid: false,
                newEntity: true,
                focus: 'NameField',
                listOptions: [
                    {
                        id: utils.generateUUID(),
                        name: '',
                        type: FieldType.ListOption,
                        editMode: true,
                        invalid: false,
                        newEntity: true,
                        focus: 'None'
                    },
                    {
                        id: utils.generateUUID(),
                        name: '',
                        type: FieldType.ListOption,
                        editMode: true,
                        invalid: false,
                        newEntity: true,
                        focus: 'None'
                    }
                ]
            });
        }
        else if (fieldType !== FieldType.Group) {
            this.group.fields.push({
                id: utils.generateUUID(),
                type: fieldType,
                name: '',
                isRequired: false,
                editMode: true,
                invalid: false,
                newEntity: true,
                focus: 'NameField'
            });
        }
    }
    filterSelectChanged(value) {
        const key = this.filters.find(f => f.value === value).key;
        this.group.filter = key;
        this.changeEntity.emit(Object.assign(Object.assign({}, this.group), { filter: key }));
    }
    fieldDeleteEventReceived(field) {
        const currentIndex = this.group.fields.indexOf(field);
        this.group.fields.splice(currentIndex, 1);
    }
    fieldMoveUpEventReceived(field) {
        const currentIndex = this.group.fields.indexOf(field);
        if (currentIndex !== 0) {
            this.group.fields.splice(currentIndex, 1);
            this.group.fields.splice(currentIndex - 1, 0, Object.assign(Object.assign({}, field), { focus: 'UpButton' }));
        }
    }
    fieldMoveDownEventReceived(field) {
        const currentIndex = this.group.fields.indexOf(field);
        if (currentIndex !== this.group.fields.length - 1) {
            this.group.fields.splice(currentIndex, 1);
            this.group.fields.splice(currentIndex + 1, 0, Object.assign(Object.assign({}, field), { focus: 'DownButton' }));
        }
    }
    groupDeleteEventReceived(obj) {
        this.groupDeleteEvent.emit(obj);
    }
    groupMoveUpEventReceived(obj) {
        this.groupMoveUp.emit(obj);
    }
    groupMoveDownEventReceived(obj) {
        this.groupMoveDown.emit(obj);
    }
    changeEventReceived(obj) {
        this.changeEntity.emit(obj);
    }
    fieldChangeEventReceived(event) {
        const oldField = this.group.fields.find(field => field.id === event.id);
        const currentIndex = this.group.fields.indexOf(oldField);
        this.group.fields.splice(currentIndex, 1, event);
    }
    canChangeLastFieldEditModeFalse(event) {
        return event.keyCode === 9 &&
            this.group &&
            this.fieldSelect &&
            this.fieldSelect.nativeElement.contains(event.target) &&
            this.group.fields.length > 0 &&
            this.canChangeEditModeToFalse(this.group.fields[this.group.fields.length - 1]);
    }
}
CustomFieldGroupComponent.ɵfac = function CustomFieldGroupComponent_Factory(t) { return new (t || CustomFieldGroupComponent)(); };
CustomFieldGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CustomFieldGroupComponent, selectors: [["bmc-custom-field-group"]], viewQuery: function CustomFieldGroupComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fieldSelect = _t.first);
    } }, hostBindings: function CustomFieldGroupComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function CustomFieldGroupComponent_keydown_HostBindingHandler($event) { return ctx.keydownTabHandler($event); });
    } }, inputs: { group: "group", filters: "filters", groupLength: "groupLength" }, outputs: { groupDeleteEvent: "groupDeleteEvent", groupMoveUp: "groupMoveUp", groupMoveDown: "groupMoveDown", changeEntity: "changeEntity", clickEvent: "clickEvent" }, decls: 40, vars: 27, consts: [[1, "card-body"], [1, "groupDomain"], ["id", "description-label"], ["aria-labelledby", "description-label", "bentoSelect", "", "name", "filterSelect", 1, "form-control", 3, "change"], ["filterSelect", "", "f", ""], [3, "ngValue", "selected", 4, "ngFor", "ngForOf"], [1, "card"], [1, "card-header"], [3, "entity", "deleteEvent", "moveUp", "moveDown", "changeEntity", "clickEvent"], [3, "group", "field", "fieldDeleteEvent", "fieldMoveUp", "fieldMoveDown", "fieldChange", "clickEvent", 4, "ngFor", "ngForOf"], ["ngbDropdown", "", 1, "d-inline-block"], ["aria-haspopup", "true", "id", "dropdownBasic1", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primary", "addNewBtn"], ["fieldSelect", ""], ["ngbDropdownMenu", "", "id", "menu-split", "role", "menu", "aria-labelledby", "Add New Element"], ["role", "menuitem", "id", "firstMenuItem", "tabindex", "0", "ngbDropdownItem", "", 3, "click"], ["role", "menuitem", "ngbDropdownItem", "", 3, "click"], ["id", "updateAriaExpand", "aria-live", "assertive", "aria-atomic", "true", 1, "sample", 2, "opacity", "0"], ["ariaLiveArea", ""], [3, "ngValue", "selected"], [3, "group", "field", "fieldDeleteEvent", "fieldMoveUp", "fieldMoveDown", "fieldChange", "clickEvent"]], template: function CustomFieldGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "select", 3, 4);
        ɵngcc0.ɵɵlistener("change", function CustomFieldGroupComponent_Template_select_change_5_listener($event) { return ctx.filterSelectChanged($event.target.value); });
        ɵngcc0.ɵɵtemplate(8, CustomFieldGroupComponent_option_8_Template, 2, 3, "option", 5);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(9, "br");
        ɵngcc0.ɵɵelementStart(10, "div", 6)(11, "div", 7)(12, "bmc-custom-field-edit-mode", 8);
        ɵngcc0.ɵɵlistener("deleteEvent", function CustomFieldGroupComponent_Template_bmc_custom_field_edit_mode_deleteEvent_12_listener($event) { return ctx.groupDeleteEventReceived($event); })("moveUp", function CustomFieldGroupComponent_Template_bmc_custom_field_edit_mode_moveUp_12_listener($event) { return ctx.groupMoveUpEventReceived($event); })("moveDown", function CustomFieldGroupComponent_Template_bmc_custom_field_edit_mode_moveDown_12_listener($event) { return ctx.groupMoveDownEventReceived($event); })("changeEntity", function CustomFieldGroupComponent_Template_bmc_custom_field_edit_mode_changeEntity_12_listener($event) { return ctx.changeEventReceived($event); })("clickEvent", function CustomFieldGroupComponent_Template_bmc_custom_field_edit_mode_clickEvent_12_listener($event) { return ctx.clickEventReceived($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(13, "div", 0);
        ɵngcc0.ɵɵtemplate(14, CustomFieldGroupComponent_bmc_custom_field_field_14_Template, 1, 2, "bmc-custom-field-field", 9);
        ɵngcc0.ɵɵelement(15, "br");
        ɵngcc0.ɵɵelementStart(16, "div", 10)(17, "button", 11, 12);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 13)(23, "button", 14);
        ɵngcc0.ɵɵlistener("click", function CustomFieldGroupComponent_Template_button_click_23_listener() { return ctx.addFieldClicked(ctx.FieldType.Textbox); });
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "button", 15);
        ɵngcc0.ɵɵlistener("click", function CustomFieldGroupComponent_Template_button_click_26_listener() { return ctx.addFieldClicked(ctx.FieldType.Date); });
        ɵngcc0.ɵɵtext(27);
        ɵngcc0.ɵɵpipe(28, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "button", 15);
        ɵngcc0.ɵɵlistener("click", function CustomFieldGroupComponent_Template_button_click_29_listener() { return ctx.addFieldClicked(ctx.FieldType.Number); });
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "button", 15);
        ɵngcc0.ɵɵlistener("click", function CustomFieldGroupComponent_Template_button_click_32_listener() { return ctx.addFieldClicked(ctx.FieldType.Checkbox); });
        ɵngcc0.ɵɵtext(33);
        ɵngcc0.ɵɵpipe(34, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "button", 15);
        ɵngcc0.ɵɵlistener("click", function CustomFieldGroupComponent_Template_button_click_35_listener() { return ctx.addFieldClicked(ctx.FieldType.List); });
        ɵngcc0.ɵɵtext(36);
        ɵngcc0.ɵɵpipe(37, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(38, "div", 16, 17);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 11, "Bluemoon.Core.CustomFields.EntityTypeDescription"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.filters);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("entity", ctx.group);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.group.fields);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-label", (ctx.group.name ? ctx.group.name : "default-name") + ", " + ɵngcc0.ɵɵpipeBind1(19, 13, "Bluemoon.Core.CustomFields.AddNew"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(21, 15, "Bluemoon.Core.CustomFields.AddNew"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(25, 17, "Bluemoon.Core.CustomFields.AddTextbox"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(28, 19, "Bluemoon.Core.CustomFields.AddDate"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(31, 21, "Bluemoon.Core.CustomFields.AddNumber"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(34, 23, "Bluemoon.Core.CustomFields.AddCheckbox"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(37, 25, "Bluemoon.Core.CustomFields.AddList"));
    } }, directives: function () { return [ɵngcc2.BentoSelectDirective, ɵngcc3.NgForOf, ɵngcc4.NgSelectOption, ɵngcc4.ɵNgSelectMultipleOption, CustomFieldEditModeComponent, CustomFieldFieldComponent, ɵngcc5.NgbDropdown, ɵngcc2.BentoFocusMonitorDirective, ɵngcc5.NgbDropdownToggle, ɵngcc2.BentoNgbDropdownAnimationDirective, ɵngcc5.NgbDropdownMenu, ɵngcc5.NgbDropdownItem]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, styles: [".card[_ngcontent-%COMP%]{margin-bottom:30px}"], changeDetection: 0 });
CustomFieldGroupComponent.propDecorators = {
    group: [{ type: Input }],
    filters: [{ type: Input }],
    groupLength: [{ type: Input }],
    groupDeleteEvent: [{ type: Output }],
    groupMoveUp: [{ type: Output }],
    groupMoveDown: [{ type: Output }],
    changeEntity: [{ type: Output }],
    clickEvent: [{ type: Output }],
    fieldSelect: [{ type: ViewChild, args: ['fieldSelect',] }],
    keydownTabHandler: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomFieldGroupComponent, [{
        type: Component,
        args: [{
                selector: 'bmc-custom-field-group',
                template: "\n  <div class=\"card-body\">\n    <div class=\"groupDomain\">\n      <label id=\"description-label\">{{'Bluemoon.Core.CustomFields.EntityTypeDescription' | translate}}</label>\n      <select #filterSelect aria-labelledby=\"description-label\" bentoSelect name=\"filterSelect\" #f (change)=\"filterSelectChanged($event.target.value)\" class=\"form-control\">\n        <option *ngFor=\"let type of filters\" [ngValue]=\"type\" [selected]=\"type.key === group.filter\">\n          {{ type.value }}\n        </option>\n      </select>\n    </div>\n    <br/>\n  <div class=\"card\">\n    <div class=\"card-header\">\n      <bmc-custom-field-edit-mode\n      [entity]=group\n      (deleteEvent)=\"groupDeleteEventReceived($event)\"\n      (moveUp)=\"groupMoveUpEventReceived($event)\"\n      (moveDown)=\"groupMoveDownEventReceived($event)\"\n      (changeEntity)= \"changeEventReceived($event)\"\n      (clickEvent)=\"clickEventReceived($event)\"\n      >\n      </bmc-custom-field-edit-mode>\n    </div>\n    <div class=\"card-body\">\n    <bmc-custom-field-field *ngFor=\"let field of group.fields\"\n      [group]=\"group\"\n      [field] = \"field\"\n      (fieldDeleteEvent)=\"fieldDeleteEventReceived($event)\"\n      (fieldMoveUp)=\"fieldMoveUpEventReceived($event)\"\n      (fieldMoveDown)=\"fieldMoveDownEventReceived($event)\"\n      (fieldChange)=\"fieldChangeEventReceived($event)\"\n      (clickEvent)=\"clickEventReceived($event)\"\n      ></bmc-custom-field-field>\n      <br/>\n\n      <div ngbDropdown class=\"d-inline-block\">\n        <button #fieldSelect aria-haspopup=\"true\" id=\"dropdownBasic1\" class=\"btn btn-outline-primary addNewBtn\" ngbDropdownToggle [attr.aria-label]=\"(group.name ? group.name : 'default-name') +', ' + ('Bluemoon.Core.CustomFields.AddNew' | translate)\">{{'Bluemoon.Core.CustomFields.AddNew' | translate}}</button>\n        <div ngbDropdownMenu id=\"menu-split\" role=\"menu\" aria-labelledby=\"Add New Element\">\n          <button role=\"menuitem\" id=\"firstMenuItem\" tabindex=\"0\" ngbDropdownItem (click)='addFieldClicked(FieldType.Textbox)'>{{'Bluemoon.Core.CustomFields.AddTextbox' | translate}}</button>\n          <button role=\"menuitem\" ngbDropdownItem (click)='addFieldClicked(FieldType.Date)'>{{'Bluemoon.Core.CustomFields.AddDate' | translate}}</button>\n          <button role=\"menuitem\" ngbDropdownItem (click)='addFieldClicked(FieldType.Number)'>{{'Bluemoon.Core.CustomFields.AddNumber' | translate}}</button>\n          <button role=\"menuitem\" ngbDropdownItem (click)='addFieldClicked(FieldType.Checkbox)'>{{'Bluemoon.Core.CustomFields.AddCheckbox' | translate}}</button>\n          <button role=\"menuitem\" ngbDropdownItem (click)='addFieldClicked(FieldType.List)'>{{'Bluemoon.Core.CustomFields.AddList' | translate}}</button>\n        </div>\n        <div #ariaLiveArea id=\"updateAriaExpand\" class=\"sample\" aria-live=\"assertive\" style=\"opacity: 0;\" aria-atomic=\"true\">\n\n        </div>\n      </div>\n    <!--  -->\n    </div>\n  </div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".card{margin-bottom:30px}"]
            }]
    }], function () { return []; }, { groupDeleteEvent: [{
            type: Output
        }], groupMoveUp: [{
            type: Output
        }], groupMoveDown: [{
            type: Output
        }], changeEntity: [{
            type: Output
        }], clickEvent: [{
            type: Output
        }], keydownTabHandler: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], group: [{
            type: Input
        }], filters: [{
            type: Input
        }], groupLength: [{
            type: Input
        }], fieldSelect: [{
            type: ViewChild,
            args: ['fieldSelect']
        }] }); })();

class CustomFieldFieldComponent {
    constructor() {
        this.fieldDeleteEvent = new EventEmitter$1();
        this.fieldMoveUp = new EventEmitter$1();
        this.fieldMoveDown = new EventEmitter$1();
        this.fieldChange = new EventEmitter$1();
        this.clickEvent = new EventEmitter$1();
        this.canChangeEditModeToFalse = canChangeEditModeToFalse;
    }
    clickEventReceived(event) {
        if (this.isHover(event.element)) {
            this.toggleEditModeTrue(event.element);
        }
        else {
            this.clickEvent.emit(event);
        }
    }
    keydownTabHandler(event) {
        if (this.isTab(event)) {
            return;
        }
        else if (this.isEnter(event)) {
            this.clickEvent.emit({ element: event.target, entity: this.group });
            this.closePreviousTab();
            this.toggleEditModeTrue(event.target);
        }
    }
    getAriaLabelledBy(name) {
        if (name) {
            return name.replace(/\s+/g, '-');
        }
        return 'default-label';
    }
    toggleEditModeTrue(el) {
        if (this.isHover(el)) {
            this.fieldChange.emit(Object.assign(Object.assign({}, this.field), { editMode: true }));
        }
    }
    deleteEventReceived(obj) {
        this.field.editMode = true;
        this.fieldDeleteEvent.emit(obj);
    }
    moveUpEventReceived(obj) {
        if (obj.type !== FieldType.Group) {
            this.fieldMoveUp.emit(obj);
        }
    }
    moveDownEventReceived(obj) {
        if (obj.type !== FieldType.Group) {
            this.fieldMoveDown.emit(obj);
        }
    }
    fieldChangeEventReceived(event) {
        if (event.type !== FieldType.List) {
            this.fieldChange.emit(event);
        }
    }
    listChangeEventReceived(event) {
        this.fieldChange.emit(event);
    }
    toggleEditModeToFalse(field) {
        if (this.canChangeEditModeToFalse(field)) {
            this.fieldChange.emit(Object.assign(Object.assign(Object.assign({}, field), field.listOptions), { editMode: false, focus: 'NameField' }));
        }
    }
    closePreviousTab() {
        const index = this.group.fields.indexOf(this.field);
        if (index > 0 && this.group.fields[index - 1].editMode) {
            this.toggleEditModeToFalse(this.group.fields[index - 1]);
        }
    }
    isHover(el) {
        return this.numberTextHover && this.numberTextHover.nativeElement.contains(el) ||
            this.dateHover && this.dateHover.nativeElement.contains(el) ||
            this.checkboxHover && this.checkboxHover.nativeElement.contains(el) ||
            this.listHover && this.listHover.nativeElement.contains(el);
    }
    isEnter(event) {
        return event.keyCode === 13;
    }
    isShiftTab(event) {
        return event.keyCode === 9 && event.shiftKey;
    }
    isTab(event) {
        return event.keyCode === 9 && !event.shiftKey;
    }
}
CustomFieldFieldComponent.ɵfac = function CustomFieldFieldComponent_Factory(t) { return new (t || CustomFieldFieldComponent)(); };
CustomFieldFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CustomFieldFieldComponent, selectors: [["bmc-custom-field-field"]], viewQuery: function CustomFieldFieldComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 5);
        ɵngcc0.ɵɵviewQuery(_c3, 5);
        ɵngcc0.ɵɵviewQuery(_c4, 5);
        ɵngcc0.ɵɵviewQuery(_c5, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.numberTextHover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dateHover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.checkboxHover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listHover = _t.first);
    } }, hostBindings: function CustomFieldFieldComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function CustomFieldFieldComponent_keydown_HostBindingHandler($event) { return ctx.keydownTabHandler($event); });
    } }, inputs: { group: "group", field: "field" }, outputs: { fieldDeleteEvent: "fieldDeleteEvent", fieldMoveUp: "fieldMoveUp", fieldMoveDown: "fieldMoveDown", fieldChange: "fieldChange", clickEvent: "clickEvent" }, decls: 9, vars: 6, consts: [[3, "hidden"], [1, "card"], [1, "card-header"], [3, "entity", "deleteEvent", "moveUp", "moveDown", "changeEntity", "listChangeEntity", "clickEvent"], [3, "hidden", 4, "ngIf"], [1, "hoverarea"], [1, "flex-container"], ["type", "text", "disabled", ""], ["tabindex", "0", "type", "button", 1, "btn", "btn-outline-primary", "editBtn"], ["numberTextHover", ""], ["disabled", ""], ["class", "calendar-icon-left", 4, "ngIf"], ["dateHover", ""], [1, "calendar-icon-left"], [1, "bento-icon-calendar"], [4, "ngIf"], ["type", "checkbox", "class", "checkbox-style", "disabled", "", 4, "ngIf"], [3, "id", 4, "ngIf"], ["checkboxHover", ""], ["type", "checkbox", "disabled", "", 1, "checkbox-style"], [3, "id"], [1, "input-container", "flex-container"], ["disabled", "", 1, "optionList"], [4, "ngFor", "ngForOf"], ["listHover", ""]], template: function CustomFieldFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "bmc-custom-field-edit-mode", 3);
        ɵngcc0.ɵɵlistener("deleteEvent", function CustomFieldFieldComponent_Template_bmc_custom_field_edit_mode_deleteEvent_3_listener($event) { return ctx.deleteEventReceived($event); })("moveUp", function CustomFieldFieldComponent_Template_bmc_custom_field_edit_mode_moveUp_3_listener($event) { return ctx.moveUpEventReceived($event); })("moveDown", function CustomFieldFieldComponent_Template_bmc_custom_field_edit_mode_moveDown_3_listener($event) { return ctx.moveDownEventReceived($event); })("changeEntity", function CustomFieldFieldComponent_Template_bmc_custom_field_edit_mode_changeEntity_3_listener($event) { return ctx.fieldChangeEventReceived($event); })("listChangeEntity", function CustomFieldFieldComponent_Template_bmc_custom_field_edit_mode_listChangeEntity_3_listener($event) { return ctx.listChangeEventReceived($event); })("clickEvent", function CustomFieldFieldComponent_Template_bmc_custom_field_edit_mode_clickEvent_3_listener($event) { return ctx.clickEventReceived($event); });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelement(4, "br");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, CustomFieldFieldComponent_div_5_Template, 12, 9, "div", 4);
        ɵngcc0.ɵɵtemplate(6, CustomFieldFieldComponent_div_6_Template, 14, 10, "div", 4);
        ɵngcc0.ɵɵtemplate(7, CustomFieldFieldComponent_div_7_Template, 4, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(8, CustomFieldFieldComponent_div_8_Template, 14, 10, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.field.editMode);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("entity", ctx.field);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.type === "number" || ctx.field.type === "textbox");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.type === "date");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.type === "checkbox");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.type === "list");
    } }, directives: function () { return [CustomFieldEditModeComponent, ɵngcc3.NgIf, ɵngcc2.BentoFocusMonitorDirective, ɵngcc4.NgSelectOption, ɵngcc4.ɵNgSelectMultipleOption, ɵngcc3.NgForOf]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, styles: [".hoverarea[_ngcontent-%COMP%]{padding:10px}.hoverarea[_ngcontent-%COMP%]:hover{background-color:#f4f5f7;border:1px solid #d5d4d9}.calendar-icon-left[_ngcontent-%COMP%]{padding-left:10px}.checkbox-style[_ngcontent-%COMP%]{box-sizing:border-box;line-height:normal;margin:4px 4px 4px 5px;padding:initial}.optionList[_ngcontent-%COMP%]{width:80%}.flex-container[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:space-between}.editBtn[_ngcontent-%COMP%]{background-color:#fff;color:#292929;cursor:pointer;font-style:bold!important;padding:0 5px!important}"], changeDetection: 0 });
CustomFieldFieldComponent.ctorParameters = () => [];
CustomFieldFieldComponent.propDecorators = {
    group: [{ type: Input }],
    field: [{ type: Input }],
    fieldDeleteEvent: [{ type: Output }],
    fieldMoveUp: [{ type: Output }],
    fieldMoveDown: [{ type: Output }],
    fieldChange: [{ type: Output }],
    clickEvent: [{ type: Output }],
    numberTextHover: [{ type: ViewChild, args: ['numberTextHover',] }],
    dateHover: [{ type: ViewChild, args: ['dateHover',] }],
    checkboxHover: [{ type: ViewChild, args: ['checkboxHover',] }],
    listHover: [{ type: ViewChild, args: ['listHover',] }],
    keydownTabHandler: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomFieldFieldComponent, [{
        type: Component,
        args: [{
                selector: 'bmc-custom-field-field',
                template: "<div [hidden]=\"!field.editMode\">\n  <div class=\"card\">\n      <div class=\"card-header\">\n          <bmc-custom-field-edit-mode\n              [entity]=field\n              (deleteEvent)=\"deleteEventReceived($event)\"\n              (moveUp)=\"moveUpEventReceived($event)\"\n              (moveDown)=\"moveDownEventReceived($event)\"\n              (changeEntity)= \"fieldChangeEventReceived($event)\"\n              (listChangeEntity) = \"listChangeEventReceived($event)\"\n              (clickEvent)=\"clickEventReceived($event)\"\n              >\n              </bmc-custom-field-edit-mode>\n      </div>\n  </div>\n  <br/>\n</div>\n<div  *ngIf=\"(field.type === 'number') || (field.type === 'textbox')\" [hidden]=\"field.editMode\">\n  <div class=\"hoverarea\">\n          <label>{{field.name}}</label><br>\n          <div class=\"flex-container\">\n            <input  type=\"text\"  disabled  [attr.aria-label]=\"field.name ? field.name : 'default-label' \">\n            <button [attr.aria-label]=\"(field.name ? field.name : 'default-name') +', ' + ('Bluemoon.DMS.Common.Buttons.Edit' | translate)\"\n             #numberTextHover tabindex=\"0\" class=\"btn btn-outline-primary editBtn\"  type=\"button\"  >\n             {{'Bluemoon.DMS.Common.Buttons.Edit' | translate}}</button>\n          </div>\n  </div>\n</div>\n\n<div  *ngIf=\"field.type === 'date'\" [hidden]=\"field.editMode\">\n  <div class=\"hoverarea\">\n          <label>{{field.name}}</label><br>\n          <div class=\"flex-container\">\n            <div>\n              <input disabled  [attr.aria-label]=\"field.name ? field.name : 'default-label' \">\n              <span class=\"calendar-icon-left\" *ngIf=\"field.type === 'date'\"><i class=\"bento-icon-calendar\"></i></span>\n            </div>\n            <button [attr.aria-label]=\"(field.name ? field.name : 'default-name') +', ' + ('Bluemoon.DMS.Common.Buttons.Edit' | translate)\"\n             #dateHover tabindex=\"0\" class=\"btn btn-outline-primary editBtn\"  type=\"button\"  >\n             {{'Bluemoon.DMS.Common.Buttons.Edit' | translate}}</button>\n          </div>\n          \n  </div>\n</div>\n\n<div *ngIf=\"field.type === 'checkbox'\" [hidden]=\"field.editMode\">\n  <div class=\"hoverarea\">\n\n    <ng-container *ngIf=\"field.type === 'checkbox'\" >\n      <div class=\"flex-container\">\n        <div>\n          <input  type=\"checkbox\" class=\"checkbox-style\" *ngIf=\"field.type === 'checkbox'\" disabled [attr.aria-labelledby]=\"getAriaLabelledBy(field.name)\" />\n          <label *ngIf=\"field.type === 'checkbox'\" [id]=\"getAriaLabelledBy(field.name)\">{{field.name}}</label><br>\n        </div>\n        <button [attr.aria-label]=\"(field.name ? field.name : 'default-name') +', ' + ('Bluemoon.DMS.Common.Buttons.Edit' | translate)\" \n        #checkboxHover tabindex=\"0\" class=\"btn btn-outline-primary editBtn\"  type=\"button\"  >\n        {{'Bluemoon.DMS.Common.Buttons.Edit' | translate}}</button>\n      </div>\n     \n    </ng-container>\n    <span class=\"calendar-icon-left\" *ngIf=\"field.type === 'date'\"><i class=\"bento-icon-calendar\"></i></span>\n  </div>\n</div>\n\n<div  *ngIf=\"field.type === 'list'\" [hidden]=\"field.editMode\">\n  <div class=\"hoverarea\" >\n    <label>{{field.name}}</label><br>\n    <div  class=\"input-container flex-container\" >\n    <select disabled class=\"optionList\"  [attr.aria-label]=\"field.name ? field.name : 'default-label' \">\n      <option disabled></option>\n      <option  *ngFor=\"let prod of field.listOptions\">{{prod.name}}</option>\n    </select>\n    <button [attr.aria-label]=\"(field.name ? field.name : 'default-name') +', ' + ('Bluemoon.DMS.Common.Buttons.Edit' | translate)\"\n      #listHover tabindex=\"0\" class=\"btn btn-outline-primary editBtn\"   type=\"button\"  >\n      {{'Bluemoon.DMS.Common.Buttons.Edit' | translate}}</button>\n    </div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".hoverarea{padding:10px}.hoverarea:hover{background-color:#f4f5f7;border:1px solid #d5d4d9}.calendar-icon-left{padding-left:10px}.checkbox-style{box-sizing:border-box;line-height:normal;margin:4px 4px 4px 5px;padding:initial}.optionList{width:80%}.flex-container{align-items:center;display:flex;justify-content:space-between}.editBtn{background-color:#fff;color:#292929;cursor:pointer;font-style:bold!important;padding:0 5px!important}"]
            }]
    }], function () { return []; }, { fieldDeleteEvent: [{
            type: Output
        }], fieldMoveUp: [{
            type: Output
        }], fieldMoveDown: [{
            type: Output
        }], fieldChange: [{
            type: Output
        }], clickEvent: [{
            type: Output
        }], keydownTabHandler: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], group: [{
            type: Input
        }], field: [{
            type: Input
        }], numberTextHover: [{
            type: ViewChild,
            args: ['numberTextHover']
        }], dateHover: [{
            type: ViewChild,
            args: ['dateHover']
        }], checkboxHover: [{
            type: ViewChild,
            args: ['checkboxHover']
        }], listHover: [{
            type: ViewChild,
            args: ['listHover']
        }] }); })();

class CustomFieldEditModeComponent {
    constructor(modalService, translationService) {
        this.modalService = modalService;
        this.translationService = translationService;
        this.FieldType = FieldType;
        this.moveClicked = false;
        this.modalOpen = false;
        this.showInvalid = false;
        this.deleteEvent = new EventEmitter$1();
        this.moveUp = new EventEmitter$1();
        this.moveDown = new EventEmitter$1();
        this.changeEntity = new EventEmitter$1();
        this.listChangeEntity = new EventEmitter$1();
        this.clickEvent = new EventEmitter$1();
        this.placeholderMap = new Map();
    }
    writeValue(obj) { }
    registerOnChange(fn) { }
    registerOnTouched(fn) { }
    setDisabledState(isDisabled) { }
    clickHandler(el) {
        const inDocument = document.contains(el);
        setTimeout(() => {
            if (!this.modalOpen && inDocument) {
                if (this.entity.editMode) {
                    this.editModeHandler(el);
                }
                else {
                    this.nonEditModeHandler(el);
                }
            }
        });
    }
    keydownTabHandler(event) {
        if (this.tabbedIntoToggle(event)) {
            this.toggleNameField();
        }
        else if (this.tabbedOutOfDeleteButton(event)) {
            setTimeout(() => {
                this.clickEvent.emit({ element: event.target, entity: this.entity });
            });
        }
        else if (this.tabbedOutOfNameFieldAndEntityIsGroup(event)) {
            this.clickEvent.emit({ element: event.target, entity: this.entity });
        }
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.getTranslations();
        });
    }
    getTranslations() {
        return __awaiter(this, void 0, void 0, function* () {
            const requiredTranslation = yield this.translationService.get('Bluemoon.Core.CustomFields.RequiredMessage').toPromise();
            this.placeholderMap.set(FieldType.Group, this.translationService
                .get('Bluemoon.Core.CustomFields.GroupPlaceholder'));
            this.placeholderMap.set(FieldType.Textbox, this.translationService
                .get('Bluemoon.Core.CustomFields.TextFieldPlaceholder'));
            this.placeholderMap.set(FieldType.Date, this.translationService
                .get('Bluemoon.Core.CustomFields.DateFieldPlaceholder'));
            this.placeholderMap.set(FieldType.Number, this.translationService
                .get('Bluemoon.Core.CustomFields.NumberFieldPlaceholder'));
            this.placeholderMap.set(FieldType.Checkbox, this.translationService
                .get('Bluemoon.Core.CustomFields.CheckboxFieldPlaceholder'));
            this.placeholderMap.set(FieldType.List, this.translationService
                .get('Bluemoon.Core.CustomFields.ListFieldPlaceholder'));
            this.placeholderMap.set(FieldType.ListOption, this.translationService
                .get('Bluemoon.Core.CustomFields.ListOptionPlaceholder'));
            this.validations = {
                required: requiredTranslation
            };
            this.groupTitle = yield this.translationService.get('Bluemoon.Core.CustomFields.DeleteModal.GroupTitle').toPromise();
            this.fieldTitle = yield this.translationService.get('Bluemoon.Core.CustomFields.DeleteModal.FieldTitle').toPromise();
            this.groupMessage = yield this.translationService.get('Bluemoon.Core.CustomFields.DeleteModal.GroupMessage').toPromise();
            this.fieldMessage = yield this.translationService.get('Bluemoon.Core.CustomFields.DeleteModal.FieldMessage').toPromise();
            this.deleteString = yield this.translationService.get('Bluemoon.Core.CustomFields.DeleteModal.Delete').toPromise();
            this.cancelString = yield this.translationService.get('Bluemoon.Core.CustomFields.DeleteModal.Cancel').toPromise();
            this.closeDialogString = yield this.translationService.get('Bluemoon.Core.CustomFields.DeleteModal.CloseDialog').toPromise();
            this.listOptionString = yield this.translationService.get('Bluemoon.Core.CustomFields.ListOptionPlaceholder').toPromise();
            this.setFormLabels();
        });
    }
    ngOnChanges() {
        if (this.entity.editMode === true) {
            if (this.entity.focus === 'DownButton') {
                this.focusDownButton();
            }
            else if (this.entity.focus === 'UpButton') {
                this.focusUpButton();
            }
            else if (this.entity.focus === 'NameField') {
                this.focusNameInput();
            }
            else if (typeof this.entity.focus === 'number') {
                this.focusListDeleteOption();
            }
        }
    }
    ngAfterViewInit() {
        const labels = document.querySelectorAll('.inputContainer');
        labels.forEach((label) => {
            var _a;
            (_a = label === null || label === void 0 ? void 0 : label.firstElementChild) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-hidden', 'true');
        });
    }
    focusUpButton() {
        setTimeout(() => {
            if (this.upButton && this.entity.editMode) {
                this.upButton.nativeElement.focus();
            }
        });
    }
    focusDownButton() {
        setTimeout(() => {
            if (this.downButton && this.entity.editMode) {
                this.downButton.nativeElement.focus();
            }
        });
    }
    focusNameInput() {
        setTimeout(() => {
            if (this.nameInputRef && this.entity.editMode && this.nameInputRef.nativeElement.value.length > 0) {
                this.deleteButton.nativeElement.focus();
            }
            else if (this.nameInputRef.nativeElement.value.length === 0) {
                this.nameInputRef.nativeElement.focus();
            }
        });
    }
    focusListDeleteOption() {
        setTimeout(() => {
            const index = this.entity.focus;
            const length = this.entity.listOptions && this.entity.listOptions.length;
            if (length <= 2 && this.newListOption) {
                this.newListOption.nativeElement.focus();
            }
            else if (this.deleteOptionButton && index < length) {
                this.deleteOptionButton.toArray()[index].nativeElement.focus();
            }
            else if (this.deleteOptionButton && index === length) {
                this.deleteOptionButton.toArray()[length - 1].nativeElement.focus();
            }
        });
    }
    editModeHandler(el) {
        if (this.isListClick(el)) {
            return;
        }
        else if (this.deleteButton && this.deleteButton.nativeElement.contains(el)) {
            this.deleteClicked();
        }
        else if (this.upButton && this.upButton.nativeElement.contains(el)) {
            this.moveUpClicked(this.entity.name);
        }
        else if (this.downButton && this.downButton.nativeElement.contains(el)) {
            this.moveDownClicked(this.entity.name);
        }
        else if (this.nameInputRef && this.nameInputRef.nativeElement.contains(el)) {
            return;
        }
        else if (this.newListOption && this.newListOption.nativeElement.contains(el)) {
            return;
        }
        else {
            this.clickEvent.emit({ element: el, entity: this.entity });
        }
    }
    nonEditModeHandler(el) {
        if (this.entity.type === FieldType.Group && this.toggleButton && this.toggleButton.nativeElement.contains(el)) {
            this.toggleNameField();
        }
        else {
            this.clickEvent.emit({ element: el, entity: this.entity });
        }
    }
    isListClick(el) {
        if ((this.deleteOptionButton && this.deleteOptionButton.find(o => o.nativeElement.contains(el)) !== undefined) ||
            (this.listOptionInput && this.listOptionInput.find((o) => o.nativeElement.contains(el)) !== undefined) ||
            (this.nameInputRef && this.nameInputRef.nativeElement.contains(el))) {
            return true;
        }
        return false;
    }
    toggleNameField() {
        this.changeEntity.emit(Object.assign(Object.assign({}, this.entity), { editMode: true }));
        setTimeout(() => {
            if (this.deleteButton) {
                this.deleteButton.nativeElement.focus();
            }
        }, 100);
    }
    deleteClicked() {
        if (!this.entity.newEntity) {
            this.modalOpen = true;
            const title = this.entity.type === FieldType.Group ? this.groupTitle : this.fieldTitle;
            const message = this.entity.type === FieldType.Group ? this.groupMessage : this.fieldMessage;
            this.modalService
                .open(message, {
                titleText: title,
                confirmButtonText: this.deleteString,
                cancelButtonText: this.cancelString,
                closeButtonText: this.closeDialogString,
            })
                .result.then((result) => {
                this.modalOpen = false;
                this.closeResult = `Closed with: ${result}`;
                if (result === BentoModalConfirmationCloseReason.Confirm) {
                    this.deleteEvent.emit(this.entity);
                }
            }, reason => {
                this.modalOpen = false;
                this.closeResult = `Dismissed ${reason}`;
            });
        }
        else {
            this.deleteEvent.emit(this.entity);
        }
    }
    deleteOptionClicked(option) {
        const currentIndex = this.entity.listOptions.indexOf(option);
        this.entity.listOptions.splice(currentIndex, 1);
        this.listChangeEntity.emit(Object.assign(Object.assign({}, this.entity), { focus: currentIndex }));
    }
    addListOption(e) {
        e.preventDefault();
        // define structur of listOption
        const newOption = {
            id: utils.generateUUID(),
            name: '',
            type: FieldType.ListOption,
            editMode: true,
            invalid: false,
            newEntity: true,
            focus: 'None'
        };
        this.entity.listOptions.push(newOption);
        this.changeEntity.emit(Object.assign({}, this.entity));
        if (this.listOptionInput) {
            setTimeout(() => {
                this.setFocusOnLastListItem();
            }, 200);
        }
    }
    tabbedIntoToggle(event) {
        return event.keyCode === 13 &&
            this.toggleButton &&
            this.toggleButton.nativeElement.contains(event.target);
    }
    tabbedOutOfDeleteButton(event) {
        return event.keyCode === 9 &&
            event.shiftKey &&
            this.deleteButton &&
            this.deleteButton.nativeElement.contains(event.target);
    }
    tabbedOutOfNameFieldAndEntityIsGroup(event) {
        return event.keyCode === 9 &&
            !event.shiftKey &&
            this.nameInputRef &&
            this.nameInputRef.nativeElement.contains(event.target) &&
            this.entity.type === FieldType.Group;
    }
    setFocusOnLastListItem() {
        this.listOptionInput.last.nativeElement.focus();
    }
    moveUpClicked(name = '') {
        console.log('moveupClicked', this.entity);
        const status = document.querySelector('#movementAnnouncement');
        if (status) {
            setTimeout(() => {
                status.textContent = '';
                status.textContent = name + ' Moved-up';
            }, 100);
        }
        this.moveUp.emit(this.entity);
    }
    // make name parameter optional
    moveDownClicked(name = '') {
        console.log('moveDownClicked', this.entity);
        const status = document.querySelector('#movementAnnouncement');
        if (status) {
            setTimeout(() => {
                status.textContent = '';
                status.textContent = name + ' Moved-down';
            }, 100);
        }
        this.moveDown.emit(this.entity);
    }
    setFormLabels() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.entity.type) {
                case FieldType.Group: {
                    this.formValidationLabel = yield this.translationService.get('Bluemoon.Core.CustomFields.FieldType.Group').toPromise();
                    break;
                }
                case FieldType.Textbox: {
                    this.formValidationLabel = yield this.translationService.get('Bluemoon.Core.CustomFields.FieldType.Textbox').toPromise();
                    break;
                }
                case FieldType.Number: {
                    this.formValidationLabel = yield this.translationService.get('Bluemoon.Core.CustomFields.FieldType.Number').toPromise();
                    break;
                }
                case FieldType.Date: {
                    this.formValidationLabel = yield this.translationService.get('Bluemoon.Core.CustomFields.FieldType.Date').toPromise();
                    break;
                }
                case FieldType.Checkbox: {
                    this.formValidationLabel = yield this.translationService.get('Bluemoon.Core.CustomFields.FieldType.Checkbox').toPromise();
                    break;
                }
                case FieldType.List: {
                    this.formValidationLabel = yield this.translationService.get('Bluemoon.Core.CustomFields.FieldType.List').toPromise();
                    this.listOptionValidationLabel = yield this.translationService.get('Bluemoon.Core.CustomFields.FieldType.ListOption').toPromise();
                    break;
                }
                default: {
                    this.formValidationLabel = '';
                    break;
                }
            }
        });
    }
}
CustomFieldEditModeComponent.ɵfac = function CustomFieldEditModeComponent_Factory(t) { return new (t || CustomFieldEditModeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.BentoModalConfirmationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService)); };
CustomFieldEditModeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CustomFieldEditModeComponent, selectors: [["bmc-custom-field-edit-mode"]], viewQuery: function CustomFieldEditModeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 5);
        ɵngcc0.ɵɵviewQuery(_c7, 5);
        ɵngcc0.ɵɵviewQuery(_c8, 5);
        ɵngcc0.ɵɵviewQuery(_c9, 5);
        ɵngcc0.ɵɵviewQuery(_c10, 5);
        ɵngcc0.ɵɵviewQuery(_c11, 5);
        ɵngcc0.ɵɵviewQuery(_c12, 5);
        ɵngcc0.ɵɵviewQuery(_c13, 5);
        ɵngcc0.ɵɵviewQuery(_c14, 5);
        ɵngcc0.ɵɵviewQuery(_c15, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.nameInputRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.containerRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.deleteButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.upButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.downButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toggleButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.newListOption = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listOptionInput = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.deleteOptionButton = _t);
    } }, hostBindings: function CustomFieldEditModeComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CustomFieldEditModeComponent_click_HostBindingHandler($event) { return ctx.clickHandler($event.target); }, false, ɵngcc0.ɵɵresolveDocument)("keydown", function CustomFieldEditModeComponent_keydown_HostBindingHandler($event) { return ctx.keydownTabHandler($event); });
    } }, inputs: { entity: "entity", firstEntity: "firstEntity", lastEntity: "lastEntity" }, outputs: { deleteEvent: "deleteEvent", moveUp: "moveUp", moveDown: "moveDown", changeEntity: "changeEntity", listChangeEntity: "listChangeEntity", clickEvent: "clickEvent" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CustomFieldEditModeComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 2, consts: [[1, "root-conatiner"], ["container", ""], ["class", "flexSpaceBetween", 4, "ngIf"], ["bfmForm", "", 3, "validations", 4, "ngIf"], ["aria-live", "assertive", "role", "alert", "id", "movementAnnouncement", "aria-atomic", "true", 1, "sr-only"], [1, "flexSpaceBetween"], ["type", "custom", 1, "editBtn"], ["toggleNameField", ""], ["bfmForm", "", 3, "validations"], ["myForm", "ngForm"], [4, "ngIf"], [1, "fieldEvents"], ["tabindex", "0"], ["deleteButton", ""], ["placement", "top-right", "class", "bento-icon-remove", 4, "ngIf"], [1, "sr-only"], ["tabindex", "0", 3, "disabled"], ["moveUpButton", ""], ["placement", "top-right", "class", "bento-icon-double-arrow-up", 4, "ngIf"], ["moveDownButton", ""], ["placement", "top-right", "class", "bento-icon-double-arrow-down", 4, "ngIf"], ["bfmField", "", "id", "name", "name", "name", "entity", "entity", "required", "", "onfocusout", "showInvalid = true", 1, "form-control", 3, "bfmLabel", "ngModel", "placeholder", "ngClass", "ngModelChange"], ["name", "ngModel", "firstNameInput", ""], ["placement", "top-right", 1, "bento-icon-remove"], ["placement", "top-right", 1, "bento-icon-double-arrow-up"], ["placement", "top-right", 1, "bento-icon-double-arrow-down"], [4, "ngFor", "ngForOf"], ["type", "button", "id", "newOptionBtn", 3, "click"], ["newListOption", ""], [1, "bento-icon-add"], [1, "parentDiv"], [1, "inputContainer"], ["id", "listOptionsStyling", "bfmField", "", "required", "", "entity", "entity", 1, "form-control", 3, "bfmLabel", "name", "ngModel", "placeholder", "ngModelChange"], ["name", "ngModel", "listOptionInput", ""], [1, "deleteOption"], ["type", "button", 3, "disabled", "click"], ["deleteOptionButton", ""]], template: function CustomFieldEditModeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, CustomFieldEditModeComponent_h2_2_Template, 7, 7, "h2", 2);
        ɵngcc0.ɵɵtemplate(3, CustomFieldEditModeComponent_form_3_Template, 33, 34, "form", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.entity.editMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.entity.editMode);
    } }, directives: [ɵngcc3.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatusGroup, ɵngcc4.NgForm, ɵngcc6.BfmFormDirective, ɵngcc4.DefaultValueAccessor, ɵngcc6.BfmFieldDirective, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc3.NgClass, ɵngcc3.NgForOf], pipes: [ɵngcc1.TranslatePipe, ɵngcc3.AsyncPipe], styles: ["button[_ngcontent-%COMP%]{background-color:transparent;background-repeat:no-repeat;border:none;cursor:pointer;overflow:hidden}#newOptionBtn[_ngcontent-%COMP%]{color:#0072a8;text-transform:uppercase}[class*=\" bento-icon-\"][_ngcontent-%COMP%], [class^=bento-icon-][_ngcontent-%COMP%]{padding-right:5px}.parentDiv[_ngcontent-%COMP%]{display:flex;width:70%}.flexSpaceBetween[_ngcontent-%COMP%]{display:flex;justify-content:space-between}#listOptionsStyling[_ngcontent-%COMP%]{float:left;width:100%}.deleteOption[_ngcontent-%COMP%]{float:right;padding-top:9px}.inputContainer[_ngcontent-%COMP%]{max-width:75%;min-width:75%}input.ng-invalid[_ngcontent-%COMP%]   .showInvalid[_ngcontent-%COMP%]{border:1px solid #dc0a0a}legend[_ngcontent-%COMP%]{font-size:14px}.editBtn[_ngcontent-%COMP%]{border:.5px solid #666;border-radius:5px}"] });
CustomFieldEditModeComponent.ctorParameters = () => [
    { type: BentoModalConfirmationService },
    { type: TranslateService }
];
CustomFieldEditModeComponent.propDecorators = {
    entity: [{ type: Input }],
    firstEntity: [{ type: Input }],
    lastEntity: [{ type: Input }],
    deleteEvent: [{ type: Output }],
    moveUp: [{ type: Output }],
    moveDown: [{ type: Output }],
    changeEntity: [{ type: Output }],
    listChangeEntity: [{ type: Output }],
    clickEvent: [{ type: Output }],
    nameInputRef: [{ type: ViewChild, args: ['firstNameInput',] }],
    listOptionInput: [{ type: ViewChildren, args: ['listOptionInput',] }],
    containerRef: [{ type: ViewChild, args: ['container',] }],
    deleteButton: [{ type: ViewChild, args: ['deleteButton',] }],
    deleteOptionButton: [{ type: ViewChildren, args: ['deleteOptionButton',] }],
    upButton: [{ type: ViewChild, args: ['moveUpButton',] }],
    downButton: [{ type: ViewChild, args: ['moveDownButton',] }],
    toggleButton: [{ type: ViewChild, args: ['toggleNameField',] }],
    newListOption: [{ type: ViewChild, args: ['newListOption',] }],
    listInput: [{ type: ViewChild, args: ['listInput',] }],
    clickHandler: [{ type: HostListener, args: ['document:click', ['$event.target'],] }],
    keydownTabHandler: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomFieldEditModeComponent, [{
        type: Component,
        args: [{
                selector: 'bmc-custom-field-edit-mode',
                template: "\n<div #container class=\"root-conatiner\">\n<h2 *ngIf=\"!entity.editMode\" class=\"flexSpaceBetween\">\n  {{entity.name}}\n  <button class=\"editBtn\" #toggleNameField type=\"custom\" [attr.aria-label]=\"(entity.name ? entity.name : 'default-name') + ', ' + ('Bluemoon.DMS.Common.Buttons.Edit' | translate)\"  >{{'Bluemoon.DMS.Common.Buttons.Edit' | translate}}</button>\n</h2>\n<form bfmForm [validations]=\"validations\" #myForm=\"ngForm\" *ngIf=\"entity.editMode\">\n    <div class=\"parentDiv\" class=\"flexSpaceBetween\">\n        <label *ngIf=\"entity.type === FieldType.Textbox\">{{'Bluemoon.Core.CustomFields.FieldType.Textbox' | translate}} *</label>\n        <label *ngIf=\"entity.type === FieldType.Date\">{{'Bluemoon.Core.CustomFields.FieldType.Date' | translate}} *</label>\n        <label *ngIf=\"entity.type === FieldType.Number\">{{'Bluemoon.Core.CustomFields.FieldType.Number' | translate}} *</label>\n        <label *ngIf=\"entity.type === FieldType.Group\">{{'Bluemoon.Core.CustomFields.FieldType.Group' | translate}} *</label>\n        <label *ngIf=\"entity.type === FieldType.Checkbox\">{{'Bluemoon.Core.CustomFields.FieldType.Checkbox' | translate}} *</label>\n        <label *ngIf=\"entity.type === FieldType.List\">{{'Bluemoon.Core.CustomFields.FieldType.List' | translate}} *</label>\n        <div class=\"fieldEvents\">\n                <button  tabindex=\"0\" #deleteButton ><i placement=\"top-right\" *ngIf=\"entity.editMode\" class=\"bento-icon-remove\"></i><span  class=\"sr-only\">{{entity.name}}, {{'Bluemoon.Core.CustomFields.DeleteModal.Delete' | translate}}</span></button>\n                <button tabindex=\"0\" #moveUpButton [disabled]=\"firstEntity\" ><i placement=\"top-right\" *ngIf=\"entity.editMode\" class=\"bento-icon-double-arrow-up\"></i><span  class=\"sr-only\">{{entity.name}}, {{'Bluemoon.Core.CustomFields.DeleteModal.MoveUp' | translate}}</span></button>\n                <button tabindex=\"0\" #moveDownButton [disabled]=\"lastEntity\" ><i placement=\"top-right\" *ngIf=\"entity.editMode\" class=\"bento-icon-double-arrow-down\"></i><span  class=\"sr-only\">{{entity.name}}, {{'Bluemoon.Core.CustomFields.DeleteModal.MoveDown' | translate}}</span></button>\n        </div>\n    </div>\n    \n  <input\n      bfmField\n      id = \"name\"\n      name=\"name\"\n      [bfmLabel]=\"formValidationLabel\"\n      class=\"form-control\"\n      [(ngModel)]= \"entity.name\"\n      #name = \"ngModel\"\n      [placeholder] = \"(placeholderMap.get(entity.type) | async) || ''\"\n      entity = \"entity\"\n      required\n      #firstNameInput\n      onfocusout=\"showInvalid = true\"\n      [ngClass]=\"{'showInvalid': showInvalid }\"\n      [attr.aria-label]=\"entity.name\"\n      >\n\n  <ng-container *ngIf=\"entity.type === FieldType.List\">\n      <br/>\n      <fieldset>\n          <legend>{{'Bluemoon.Core.CustomFields.Options' | translate}} *</legend>\n      <div *ngFor=\"let option of entity.listOptions; let i = index;\">\n          <div class=\"parentDiv\">\n              <div class=\"inputContainer\">\n                    <input id=\"listOptionsStyling\"\n                    bfmField\n                    [bfmLabel]=\"listOptionValidationLabel\"\n                  name=\"optionName{{i}}\"\n                  class=\"form-control\"\n                  [(ngModel)]=\"option.name\"\n                  #name=\"ngModel\"\n                  required\n                  placeholder = \"{{listOptionString}} {{i+1}}\"\n                  #listOptionInput\n                  entity = \"entity\"\n                  />\n              </div>\n              <div class=\"deleteOption\">\n                <button #deleteOptionButton type=\"button\" (click)=deleteOptionClicked(option) [disabled]=\"entity.listOptions.length <= 2\">\n                  <i placement=\"top-right\" *ngIf=\"entity.editMode\" class=\"bento-icon-remove\"></i><span  class=\"sr-only\">{{option.name}}, {{'Bluemoon.Core.CustomFields.DeleteModal.Delete' | translate}}</span>\n                </button>\n              </div>\n          </div>\n          <br/>\n      </div>\n      <button #newListOption type=\"button\" id=\"newOptionBtn\" (click)=\"addListOption($event)\"><span class=\"bento-icon-add\"></span>{{'Bluemoon.Core.CustomFields.AddOption' | translate}}</button>\n    </fieldset>\n    </ng-container>\n</form>\n</div>\n<div aria-live=\"assertive\" role=\"alert\" class=\"sr-only\" id=\"movementAnnouncement\" aria-atomic=\"true\"></div>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CustomFieldEditModeComponent),
                        multi: true
                    }
                ],
                styles: ["button{background-color:transparent;background-repeat:no-repeat;border:none;cursor:pointer;overflow:hidden}#newOptionBtn{color:#0072a8;text-transform:uppercase}[class*=\" bento-icon-\"],[class^=bento-icon-]{padding-right:5px}.parentDiv{display:flex;width:70%}.flexSpaceBetween{display:flex;justify-content:space-between}#listOptionsStyling{float:left;width:100%}.deleteOption{float:right;padding-top:9px}.inputContainer{max-width:75%;min-width:75%}input.ng-invalid .showInvalid{border:1px solid #dc0a0a}legend{font-size:14px}.editBtn{border:.5px solid #666;border-radius:5px}"]
            }]
    }], function () { return [{ type: ɵngcc2.BentoModalConfirmationService }, { type: ɵngcc1.TranslateService }]; }, { deleteEvent: [{
            type: Output
        }], moveUp: [{
            type: Output
        }], moveDown: [{
            type: Output
        }], changeEntity: [{
            type: Output
        }], listChangeEntity: [{
            type: Output
        }], clickEvent: [{
            type: Output
        }], clickHandler: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }], keydownTabHandler: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], entity: [{
            type: Input
        }], firstEntity: [{
            type: Input
        }], lastEntity: [{
            type: Input
        }], nameInputRef: [{
            type: ViewChild,
            args: ['firstNameInput']
        }], listOptionInput: [{
            type: ViewChildren,
            args: ['listOptionInput']
        }], containerRef: [{
            type: ViewChild,
            args: ['container']
        }], deleteButton: [{
            type: ViewChild,
            args: ['deleteButton']
        }], deleteOptionButton: [{
            type: ViewChildren,
            args: ['deleteOptionButton']
        }], upButton: [{
            type: ViewChild,
            args: ['moveUpButton']
        }], downButton: [{
            type: ViewChild,
            args: ['moveDownButton']
        }], toggleButton: [{
            type: ViewChild,
            args: ['toggleNameField']
        }], newListOption: [{
            type: ViewChild,
            args: ['newListOption']
        }], listInput: [{
            type: ViewChild,
            args: ['listInput']
        }] }); })();

class CustomFieldsModule {
}
CustomFieldsModule.ɵfac = function CustomFieldsModule_Factory(t) { return new (t || CustomFieldsModule)(); };
CustomFieldsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CustomFieldsModule });
CustomFieldsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [CustomFieldsService, FormElementsService, DatePipe, BentoModalConfirmationService], imports: [[
            BentoModule,
            CommonModule,
            FormsModule,
            NgbDropdownModule,
            BfmModule,
            TranslateModule.forChild()
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomFieldsModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomFieldsComponent,
                    CustomFieldGroupComponent,
                    CustomFieldFieldComponent,
                    CustomFieldEditModeComponent,
                    FormElementsComponent],
                imports: [
                    BentoModule,
                    CommonModule,
                    FormsModule,
                    NgbDropdownModule,
                    BfmModule,
                    TranslateModule.forChild()
                ],
                exports: [CustomFieldsComponent, FormElementsComponent],
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                providers: [CustomFieldsService, FormElementsService, DatePipe, BentoModalConfirmationService],
                entryComponents: [FormElementsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CustomFieldsModule, { declarations: function () { return [CustomFieldsComponent, CustomFieldGroupComponent, CustomFieldFieldComponent, CustomFieldEditModeComponent, FormElementsComponent]; }, imports: function () { return [BentoModule,
        CommonModule,
        FormsModule,
        NgbDropdownModule,
        BfmModule, ɵngcc1.TranslateModule]; }, exports: function () { return [CustomFieldsComponent, FormElementsComponent]; } }); })();

/*
 * Public API Surface of custom-fields
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CallbackType, CustomFieldsComponent, CustomFieldsModule, CustomFieldsService, FormElementsComponent, FormElementsService, SaveType, canChangeEditModeToFalse, entityValid, CustomFieldGroupComponent as ɵa, CustomFieldFieldComponent as ɵb, CustomFieldEditModeComponent as ɵc };

